import React from "react";

interface IClassNameProps {
  className?: string;
}

//WARNING!! PLease do not edit any of these icons
//These Files Consist of Custom Icons which has Multi Colors.

export const LogoPortProSmall = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9429 3.48571C16.2 2.37143 15.1714 1.51429 13.8571 0.914286C12.5143 0.314286 10.9429 0 9.14286 0H0V4.45714H8.8C9.94286 4.45714 10.8286 4.71429 11.4286 5.22857C12 5.74286 12.3143 6.48572 12.3143 7.4C12.3143 8.34286 12 9.05714 11.4286 9.57143C10.8286 10.0857 9.94286 10.3143 8.8 10.3143H0V20H5.65714V14.7714H9.14286C10.9429 14.7714 12.5143 14.4857 13.8571 13.8857C15.1714 13.2857 16.2 12.4286 16.9429 11.3143C17.6571 10.2286 18.0286 8.91429 18.0286 7.4C18.0286 5.91429 17.6571 4.6 16.9429 3.48571Z"
      fill="white"
    />
  </svg>
);


export const LogoPortPro = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="142"
    height="20"
    viewBox="0 0 142 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2165 20C28.1835 20 26.3429 19.5879 24.722 18.7088C23.1011 17.8571 21.8374 16.6758 20.9033 15.1374C19.9692 13.6264 19.5297 11.9231 19.5297 10C19.5297 8.1044 19.9692 6.4011 20.9033 4.86264C21.8374 3.35165 23.1011 2.17033 24.722 1.29121C26.3429 0.439559 28.1835 0 30.2165 0C32.2495 0 34.0627 0.439559 35.6835 1.29121C37.3044 2.17033 38.5681 3.35165 39.5022 4.86264C40.4363 6.4011 40.9033 8.1044 40.9033 10C40.9033 11.9231 40.4363 13.6264 39.5022 15.1374C38.5681 16.6758 37.3044 17.8571 35.6835 18.7088C34.0627 19.5879 32.2495 20 30.2165 20ZM30.2165 15.4945C31.178 15.4945 32.0572 15.2747 32.8539 14.8077C33.6231 14.3681 34.255 13.7088 34.722 12.8846C35.1616 12.0604 35.4088 11.0989 35.4088 10C35.4088 8.92857 35.1616 7.96703 34.722 7.14285C34.255 6.31868 33.6231 5.65934 32.8539 5.19231C32.0572 4.75275 31.178 4.50549 30.2165 4.50549C29.2275 4.50549 28.3484 4.75275 27.5791 5.19231C26.7824 5.65934 26.1506 6.31868 25.711 7.14285C25.244 7.96703 25.0242 8.92857 25.0242 10C25.0242 11.0989 25.244 12.0604 25.711 12.8846C26.1506 13.7088 26.7824 14.3681 27.5791 14.8077C28.3484 15.2747 29.2275 15.4945 30.2165 15.4945ZM13.5107 1.12639C14.7921 1.71139 15.795 2.54711 16.5193 3.63353C17.2157 4.71996 17.5779 6.00139 17.5779 7.44996C17.5779 8.92639 17.2157 10.2078 16.5193 11.2664C15.795 12.3528 14.7921 13.1885 13.5107 13.7735C12.2014 14.3585 10.6693 14.6371 8.91429 14.6371H5.51571V19.735H0V10.2914H8.58C9.69428 10.2914 10.5579 10.0685 11.1429 9.5671C11.7 9.06568 12.0064 8.36925 12.0064 7.44996C12.0064 6.55853 11.7 5.83425 11.1429 5.33282C10.5579 4.83139 9.69428 4.58068 8.58 4.58068H0V0.234961H8.91429C10.6693 0.234961 12.2014 0.54139 13.5107 1.12639ZM57.3238 13.5714C58.5051 12.9945 59.4392 12.1978 60.0985 11.1538C60.7578 10.1099 61.0875 8.9011 61.0875 7.5C61.0875 6.07143 60.7304 4.8077 60.0435 3.73627C59.3293 2.66484 58.3403 1.84066 57.0765 1.26374C55.7853 0.686817 54.2743 0.384619 52.5436 0.384619H43.7523V4.67033H52.2139C53.3128 4.67033 54.1644 4.91759 54.7414 5.41209C55.2908 5.9066 55.593 6.62088 55.593 7.5C55.593 8.4066 55.2908 9.09341 54.7414 9.58792C54.1644 10.0824 53.3128 10.3022 52.2139 10.3022H43.7523V19.6154H49.1919V14.5055H52.1589L55.6479 19.6154H61.4721L57.3238 13.5714ZM67.9136 19.6154V4.69781H62.007V0.384619H79.2323V4.69781H73.3532V19.6154H67.9136Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M131.253 20C129.22 20 127.38 19.5879 125.759 18.7088C124.138 17.8571 122.874 16.6758 121.94 15.1374C121.006 13.6264 120.566 11.9231 120.566 10C120.566 8.1044 121.006 6.4011 121.94 4.86264C122.874 3.35165 124.138 2.17033 125.759 1.29121C127.38 0.439559 129.22 0 131.253 0C133.286 0 135.099 0.439559 136.72 1.29121C138.341 2.17033 139.605 3.35165 140.539 4.86264C141.473 6.4011 141.94 8.1044 141.94 10C141.94 11.9231 141.473 13.6264 140.539 15.1374C139.605 16.6758 138.341 17.8571 136.72 18.7088C135.099 19.5879 133.286 20 131.253 20ZM131.253 15.4945C132.215 15.4945 133.094 15.2747 133.891 14.8077C134.66 14.3681 135.292 13.7088 135.759 12.8846C136.198 12.0604 136.446 11.0989 136.446 10C136.446 8.92857 136.198 7.96703 135.759 7.14285C135.292 6.31868 134.66 5.65934 133.891 5.19231C133.094 4.75275 132.215 4.50549 131.253 4.50549C130.264 4.50549 129.385 4.75275 128.616 5.19231C127.819 5.65934 127.187 6.31868 126.748 7.14285C126.281 7.96703 126.061 8.92857 126.061 10C126.061 11.0989 126.281 12.0604 126.748 12.8846C127.187 13.7088 127.819 14.3681 128.616 14.8077C129.385 15.2747 130.264 15.4945 131.253 15.4945ZM97.55 3.73627C96.8357 2.66484 95.8467 1.84066 94.583 1.26374C93.2918 0.686817 91.7808 0.384619 90.05 0.384619H81.2588V4.67033H89.7203C90.8192 4.67033 91.6709 4.91759 92.2478 5.41209C92.7973 5.9066 93.0995 6.62088 93.0995 7.5C93.0995 8.4066 92.7973 9.09341 92.2478 9.58792C91.6709 10.0824 90.8192 10.3022 89.7203 10.3022H81.2588V19.6154H86.6984V14.5879H90.05C91.7808 14.5879 93.2918 14.3132 94.583 13.7363C95.8467 13.1593 96.8357 12.3352 97.55 11.2637C98.2368 10.2198 98.594 8.95605 98.594 7.5C98.594 6.07143 98.2368 4.8077 97.55 3.73627ZM114.791 13.5714C115.972 12.9945 116.906 12.1978 117.565 11.1538C118.225 10.1099 118.554 8.9011 118.554 7.5C118.554 6.07143 118.197 4.8077 117.51 3.73627C116.796 2.66484 115.807 1.84066 114.543 1.26374C113.252 0.686817 111.741 0.384619 110.01 0.384619H101.219V4.67033H109.681C110.78 4.67033 111.631 4.91759 112.208 5.41209C112.758 5.9066 113.06 6.62088 113.06 7.5C113.06 8.4066 112.758 9.09341 112.208 9.58792C111.631 10.0824 110.78 10.3022 109.681 10.3022H101.219V19.6154H106.659V14.5055H109.626L113.115 19.6154H118.939L114.791 13.5714Z"
      fill="#C2D6FC"
    />
  </svg>
);


export const CheckoutLogoPortPro = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="142"
    height="20"
    viewBox="0 0 142 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2165 20C28.1835 20 26.3429 19.5879 24.722 18.7088C23.1011 17.8571 21.8374 16.6758 20.9033 15.1374C19.9692 13.6264 19.5297 11.9231 19.5297 10C19.5297 8.1044 19.9692 6.4011 20.9033 4.86264C21.8374 3.35165 23.1011 2.17033 24.722 1.29121C26.3429 0.439559 28.1835 0 30.2165 0C32.2495 0 34.0627 0.439559 35.6835 1.29121C37.3044 2.17033 38.5681 3.35165 39.5022 4.86264C40.4363 6.4011 40.9033 8.1044 40.9033 10C40.9033 11.9231 40.4363 13.6264 39.5022 15.1374C38.5681 16.6758 37.3044 17.8571 35.6835 18.7088C34.0627 19.5879 32.2495 20 30.2165 20ZM30.2165 15.4945C31.178 15.4945 32.0572 15.2747 32.8539 14.8077C33.6231 14.3681 34.255 13.7088 34.722 12.8846C35.1616 12.0604 35.4088 11.0989 35.4088 10C35.4088 8.92857 35.1616 7.96703 34.722 7.14285C34.255 6.31868 33.6231 5.65934 32.8539 5.19231C32.0572 4.75275 31.178 4.50549 30.2165 4.50549C29.2275 4.50549 28.3484 4.75275 27.5791 5.19231C26.7824 5.65934 26.1506 6.31868 25.711 7.14285C25.244 7.96703 25.0242 8.92857 25.0242 10C25.0242 11.0989 25.244 12.0604 25.711 12.8846C26.1506 13.7088 26.7824 14.3681 27.5791 14.8077C28.3484 15.2747 29.2275 15.4945 30.2165 15.4945ZM13.5107 1.12639C14.7921 1.71139 15.795 2.54711 16.5193 3.63353C17.2157 4.71996 17.5779 6.00139 17.5779 7.44996C17.5779 8.92639 17.2157 10.2078 16.5193 11.2664C15.795 12.3528 14.7921 13.1885 13.5107 13.7735C12.2014 14.3585 10.6693 14.6371 8.91429 14.6371H5.51571V19.735H0V10.2914H8.58C9.69428 10.2914 10.5579 10.0685 11.1429 9.5671C11.7 9.06568 12.0064 8.36925 12.0064 7.44996C12.0064 6.55853 11.7 5.83425 11.1429 5.33282C10.5579 4.83139 9.69428 4.58068 8.58 4.58068H0V0.234961H8.91429C10.6693 0.234961 12.2014 0.54139 13.5107 1.12639ZM57.3238 13.5714C58.5051 12.9945 59.4392 12.1978 60.0985 11.1538C60.7578 10.1099 61.0875 8.9011 61.0875 7.5C61.0875 6.07143 60.7304 4.8077 60.0435 3.73627C59.3293 2.66484 58.3403 1.84066 57.0765 1.26374C55.7853 0.686817 54.2743 0.384619 52.5436 0.384619H43.7523V4.67033H52.2139C53.3128 4.67033 54.1644 4.91759 54.7414 5.41209C55.2908 5.9066 55.593 6.62088 55.593 7.5C55.593 8.4066 55.2908 9.09341 54.7414 9.58792C54.1644 10.0824 53.3128 10.3022 52.2139 10.3022H43.7523V19.6154H49.1919V14.5055H52.1589L55.6479 19.6154H61.4721L57.3238 13.5714ZM67.9136 19.6154V4.69781H62.007V0.384619H79.2323V4.69781H73.3532V19.6154H67.9136Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M131.253 20C129.22 20 127.38 19.5879 125.759 18.7088C124.138 17.8571 122.874 16.6758 121.94 15.1374C121.006 13.6264 120.566 11.9231 120.566 10C120.566 8.1044 121.006 6.4011 121.94 4.86264C122.874 3.35165 124.138 2.17033 125.759 1.29121C127.38 0.439559 129.22 0 131.253 0C133.286 0 135.099 0.439559 136.72 1.29121C138.341 2.17033 139.605 3.35165 140.539 4.86264C141.473 6.4011 141.94 8.1044 141.94 10C141.94 11.9231 141.473 13.6264 140.539 15.1374C139.605 16.6758 138.341 17.8571 136.72 18.7088C135.099 19.5879 133.286 20 131.253 20ZM131.253 15.4945C132.215 15.4945 133.094 15.2747 133.891 14.8077C134.66 14.3681 135.292 13.7088 135.759 12.8846C136.198 12.0604 136.446 11.0989 136.446 10C136.446 8.92857 136.198 7.96703 135.759 7.14285C135.292 6.31868 134.66 5.65934 133.891 5.19231C133.094 4.75275 132.215 4.50549 131.253 4.50549C130.264 4.50549 129.385 4.75275 128.616 5.19231C127.819 5.65934 127.187 6.31868 126.748 7.14285C126.281 7.96703 126.061 8.92857 126.061 10C126.061 11.0989 126.281 12.0604 126.748 12.8846C127.187 13.7088 127.819 14.3681 128.616 14.8077C129.385 15.2747 130.264 15.4945 131.253 15.4945ZM97.55 3.73627C96.8357 2.66484 95.8467 1.84066 94.583 1.26374C93.2918 0.686817 91.7808 0.384619 90.05 0.384619H81.2588V4.67033H89.7203C90.8192 4.67033 91.6709 4.91759 92.2478 5.41209C92.7973 5.9066 93.0995 6.62088 93.0995 7.5C93.0995 8.4066 92.7973 9.09341 92.2478 9.58792C91.6709 10.0824 90.8192 10.3022 89.7203 10.3022H81.2588V19.6154H86.6984V14.5879H90.05C91.7808 14.5879 93.2918 14.3132 94.583 13.7363C95.8467 13.1593 96.8357 12.3352 97.55 11.2637C98.2368 10.2198 98.594 8.95605 98.594 7.5C98.594 6.07143 98.2368 4.8077 97.55 3.73627ZM114.791 13.5714C115.972 12.9945 116.906 12.1978 117.565 11.1538C118.225 10.1099 118.554 8.9011 118.554 7.5C118.554 6.07143 118.197 4.8077 117.51 3.73627C116.796 2.66484 115.807 1.84066 114.543 1.26374C113.252 0.686817 111.741 0.384619 110.01 0.384619H101.219V4.67033H109.681C110.78 4.67033 111.631 4.91759 112.208 5.41209C112.758 5.9066 113.06 6.62088 113.06 7.5C113.06 8.4066 112.758 9.09341 112.208 9.58792C111.631 10.0824 110.78 10.3022 109.681 10.3022H101.219V19.6154H106.659V14.5055H109.626L113.115 19.6154H118.939L114.791 13.5714Z"
      fill="#0d99ff"
    />
  </svg>
);

export const IconTimes = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99983 7.3687L4.79983 4.1687L3.66846 5.30007L6.86846 8.50007L3.66846 11.7001L4.79983 12.8314L7.99983 9.63144L11.1998 12.8314L12.3312 11.7001L9.1312 8.50007L12.3312 5.30007L11.1998 4.1687L7.99983 7.3687Z"
      fill="currentColor"
    />
  </svg>
);

export const IconAmericanExpress = ({ className }: React.HTMLAttributes<HTMLDivElement>) => (
  <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M43.125 9H4.875C3.287 9 2 10.287 2 11.875V36.125C2 37.713 3.287 39 4.875 39H43.125C44.713 39 46 37.713 46 36.125V11.875C46 10.287 44.713 9 43.125 9Z"
      fill="url(#paint0_linear_1_16)"
    />
    <path
      opacity="0.05"
      d="M23.778 27.981C22.951 27.981 22.278 27.308 22.278 26.481V26.44L21.969 27.109C21.725 27.638 21.19 27.981 20.607 27.981H19.69C19.097 27.981 18.559 27.631 18.319 27.089L18.065 26.517C18.046 27.328 17.381 27.981 16.565 27.981H13.927C13.331 27.981 12.792 27.628 12.553 27.083L12.264 26.423H10.144L9.864 27.074C9.626 27.625 9.085 27.981 8.486 27.981H7.383C6.694 27.981 6.133 27.42 6.133 26.731V26.676L6.145 26.556L6.179 26.4L9.019 19.897C9.261 19.352 9.8 19 10.394 19H12.017C12.607 19 13.144 19.348 13.386 19.887L14.344 22.033V20.5C14.344 19.673 15.017 19 15.844 19H17.716C18.305 19 18.842 19.347 19.084 19.885L20.145 22.247L21.212 19.884C21.453 19.347 21.99 19 22.578 19H24.5C25.327 19 26 19.673 26 20.5V26.481C26 27.308 25.327 27.981 24.5 27.981H23.778Z"
      fill="black"
    />
    <path
      opacity="0.07"
      d="M23.778 27.481C23.227 27.481 22.778 27.032 22.778 26.481V24.163L21.515 26.9C21.352 27.253 20.996 27.481 20.607 27.481H19.69C19.295 27.481 18.936 27.248 18.776 26.886L17.566 24.157V26.481C17.566 27.032 17.117 27.481 16.566 27.481H13.928C13.531 27.481 13.171 27.246 13.012 26.882L12.592 25.923H9.815L9.405 26.877C9.246 27.244 8.886 27.481 8.486 27.481H7.383C6.969 27.481 6.633 27.145 6.633 26.731V26.664L6.668 26.508L9.478 20.097C9.639 19.734 9.998 19.499 10.394 19.499H12.017C12.411 19.499 12.768 19.731 12.93 20.09L14.845 24.378V20.5C14.845 19.949 15.294 19.5 15.845 19.5H17.717C18.11 19.5 18.468 19.731 18.629 20.09L20.145 23.465L21.668 20.089C21.83 19.731 22.188 19.5 22.58 19.5H24.5C25.051 19.5 25.5 19.949 25.5 20.5V26.481C25.5 27.032 25.051 27.481 24.5 27.481H23.778ZM11.463 23.415L11.17 22.744L10.888 23.415H11.463Z"
      fill="black"
    />
    <path
      d="M24.5 20H22.578C22.381 20 22.203 20.115 22.122 20.294L20.142 24.683L18.172 20.295C18.091 20.116 17.912 20 17.715 20H15.844C15.568 20 15.344 20.224 15.344 20.5V26.726L12.473 20.296C12.393 20.116 12.214 20 12.017 20H10.394C10.196 20 10.016 20.117 9.936 20.299L7.15 26.64C7.15 26.64 7.133 26.703 7.133 26.731C7.133 26.869 7.245 26.981 7.383 26.981H8.486C8.686 26.981 8.866 26.862 8.945 26.679L9.486 25.423H12.918L13.469 26.681C13.549 26.863 13.728 26.98 13.927 26.98H16.565C16.841 26.98 17.065 26.756 17.065 26.48V21.795L19.232 26.683C19.312 26.864 19.491 26.98 19.689 26.98H20.607C20.802 26.98 20.979 26.867 21.061 26.69L23.278 21.885V26.48C23.278 26.756 23.502 26.98 23.778 26.98H24.5C24.776 26.98 25 26.756 25 26.48V20.5C25 20.224 24.776 20 24.5 20ZM10.135 23.915L11.161 21.475L12.227 23.915H10.135Z"
      fill="white"
    />
    <path
      opacity="0.05"
      d="M38.994 28C38.561 28 38.15 27.813 37.865 27.488L36.715 26.175L35.526 27.488C35.243 27.801 34.838 27.982 34.414 27.982H28.5C27.673 27.982 27 27.309 27 26.482V20.5C27 19.673 27.673 19 28.5 19H35.311L36.805 20.69L38.115 19.268L38.214 19.226C38.359 19.107 38.619 19.019 38.893 19.019H40.434C41.123 19.019 41.684 19.58 41.684 20.269C41.684 20.473 41.632 20.778 41.382 21.073L39.222 23.433L41.783 26.403L41.68 26.643C41.683 26.679 41.685 26.715 41.685 26.75C41.685 27.439 41.124 28 40.435 28H38.994V28Z"
      fill="black"
    />
    <path
      opacity="0.07"
      d="M38.994 27.5C38.705 27.5 38.431 27.375 38.242 27.159L36.721 25.423L35.155 27.153C34.967 27.362 34.696 27.482 34.414 27.482H28.5C27.949 27.482 27.5 27.033 27.5 26.482V20.5C27.5 19.949 27.949 19.5 28.5 19.5H35.085L36.796 21.436L38.408 19.686L38.441 19.672C38.571 19.573 38.727 19.519 38.891 19.519H40.432C40.846 19.519 41.182 19.855 41.182 20.269C41.182 20.39 41.15 20.571 40.998 20.75L38.551 23.423L41.198 26.492L41.161 26.577C41.175 26.633 41.182 26.691 41.182 26.749C41.182 27.163 40.846 27.499 40.432 27.499H38.994V27.5ZM33.507 25.016L33.854 24.635H30.216V25.016H33.507ZM34.055 24.415L34.971 23.41L34.055 22.384V24.415ZM33.991 22.312L33.726 22.016L30.216 22.006V22.313H33.991V22.312Z"
      fill="black"
    />
    <path
      d="M40.615 26.586L40.616 26.583L37.882 23.414L40.616 20.428C40.653 20.384 40.682 20.331 40.682 20.269C40.682 20.131 40.57 20.019 40.432 20.019C40.425 20.019 38.894 20.019 38.891 20.019C38.819 20.019 38.756 20.052 38.711 20.101L38.704 20.104L36.788 22.183L34.86 20H28.5C28.224 20 28 20.224 28 20.5V26.482C28 26.758 28.224 26.982 28.5 26.982H34.413C34.554 26.982 34.689 26.922 34.784 26.818L36.727 24.671L38.618 26.829C38.713 26.938 38.85 27 38.994 27H40.434C40.572 27 40.684 26.888 40.684 26.75C40.683 26.686 40.655 26.63 40.615 26.586ZM33.728 25.516H29.717V24.135H33.555V22.812H29.717V21.504L33.951 21.516L35.644 23.413L33.728 25.516Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_16"
        x1="20.375"
        y1="11.061"
        x2="28.748"
        y2="40.946"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B3EE" />
        <stop offset="1" stopColor="#0082D8" />
      </linearGradient>
    </defs>
  </svg>
);

export const IconApple = ({ className }: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    fill="#000000"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30px"
    height="30px"
  >
    <path
      d="M25.565,9.785c-0.123,0.077-3.051,1.702-3.051,5.305c0.138,4.109,3.695,5.55,3.756,5.55 c-0.061,0.077-0.537,1.963-1.947,3.94C23.204,26.283,21.962,28,20.076,28c-1.794,0-2.438-1.135-4.508-1.135 c-2.223,0-2.852,1.135-4.554,1.135c-1.886,0-3.22-1.809-4.4-3.496c-1.533-2.208-2.836-5.673-2.882-9 c-0.031-1.763,0.307-3.496,1.165-4.968c1.211-2.055,3.373-3.45,5.734-3.496c1.809-0.061,3.419,1.242,4.523,1.242 c1.058,0,3.036-1.242,5.274-1.242C21.394,7.041,23.97,7.332,25.565,9.785z M15.001,6.688c-0.322-1.61,0.567-3.22,1.395-4.247 c1.058-1.242,2.729-2.085,4.17-2.085c0.092,1.61-0.491,3.189-1.533,4.339C18.098,5.937,16.488,6.872,15.001,6.688z"
      fill="currentColor"
    />
  </svg>
);


export const IconMasterCard = ({ className }: React.HTMLAttributes<HTMLDivElement>) => (
  <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M43.125 9H4.875C3.28516 9 2 10.2852 2 11.875V36.125C2 37.7148 3.28516 39 4.875 39H43.125C44.7148 39 46 37.7148 46 36.125V11.875C46 10.2852 44.7148 9 43.125 9Z"
      fill="#333333"
    />
    <path
      d="M27.1055 24.0547C27.1055 29.6055 22.6055 34.1055 17.0547 34.1055C11.5 34.1055 7 29.6055 7 24.0547C7 18.5 11.5 14 17.0547 14C22.6055 14 27.1055 18.5 27.1055 24.0547Z"
      fill="#CF1928"
    />
    <path
      d="M40.1055 24.0547C40.1055 29.6055 35.6055 34.1055 30.0547 34.1055C24.5 34.1055 20 29.6055 20 24.0547C20 18.5 24.5 14 30.0547 14C35.6055 14 40.1055 18.5 40.1055 24.0547Z"
      fill="url(#paint0_linear_1_9)"
    />
    <path
      d="M20 24.0547C20 27.125 21.3828 29.8711 23.5547 31.7148C25.7266 29.8711 27.1055 27.125 27.1055 24.0547C27.1055 20.9805 25.7227 18.2344 23.5547 16.3906C21.3828 18.2344 20 20.9805 20 24.0547Z"
      fill="#D97218"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_9"
        x1="71.6666"
        y1="86.1898"
        x2="143.717"
        y2="86.1898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDE00" />
        <stop offset="1" stopColor="#FFD000" />
      </linearGradient>
    </defs>
  </svg>
);

export const LogoPortProColorSmall = ({ className }: IClassNameProps) => (
  <svg width="64" height="20" viewBox="0 0 64 20" fill="none" className={`cicon ${className}`} xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.487 14C15.6738 14 14.9375 13.8352 14.2892 13.4835C13.6408 13.1429 13.1353 12.6703 12.7617 12.0549C12.3881 11.4505 12.2123 10.7692 12.2123 10C12.2123 9.24176 12.3881 8.56044 12.7617 7.94505C13.1353 7.34066 13.6408 6.86813 14.2892 6.51648C14.9375 6.17582 15.6738 6 16.487 6C17.3002 6 18.0255 6.17582 18.6738 6.51648C19.3222 6.86813 19.8277 7.34066 20.2013 7.94505C20.5749 8.56044 20.7617 9.24176 20.7617 10C20.7617 10.7692 20.5749 11.4505 20.2013 12.0549C19.8277 12.6703 19.3222 13.1429 18.6738 13.4835C18.0255 13.8352 17.3002 14 16.487 14ZM16.487 12.1978C16.8716 12.1978 17.2233 12.1099 17.5419 11.9231C17.8496 11.7473 18.1024 11.4835 18.2892 11.1538C18.465 10.8242 18.5639 10.4396 18.5639 10C18.5639 9.57143 18.465 9.18681 18.2892 8.85714C18.1024 8.52747 17.8496 8.26374 17.5419 8.07692C17.2233 7.9011 16.8716 7.8022 16.487 7.8022C16.0914 7.8022 15.7397 7.9011 15.432 8.07692C15.1134 8.26374 14.8606 8.52747 14.6848 8.85714C14.498 9.18681 14.4101 9.57143 14.4101 10C14.4101 10.4396 14.498 10.8242 14.6848 11.1538C14.8606 11.4835 15.1134 11.7473 15.432 11.9231C15.7397 12.1099 16.0914 12.1978 16.487 12.1978ZM9.80467 6.45056C10.3172 6.68456 10.7184 7.01884 11.0081 7.45341C11.2867 7.88799 11.4315 8.40056 11.4315 8.97999C11.4315 9.57056 11.2867 10.0831 11.0081 10.5066C10.7184 10.9411 10.3172 11.2754 9.80467 11.5094C9.28096 11.7434 8.66811 11.8548 7.96611 11.8548H6.60667V13.894H4.40039V10.1166H7.83239C8.2781 10.1166 8.62353 10.0274 8.85753 9.82684C9.08039 9.62627 9.20296 9.3477 9.20296 8.97999C9.20296 8.62341 9.08039 8.3337 8.85753 8.13313C8.62353 7.93256 8.2781 7.83227 7.83239 7.83227H4.40039V6.09399H7.96611C8.66811 6.09399 9.28096 6.21656 9.80467 6.45056ZM27.3299 11.4286C27.8024 11.1978 28.1761 10.8791 28.4398 10.4615C28.7035 10.044 28.8354 9.56044 28.8354 9C28.8354 8.42858 28.6925 7.92308 28.4178 7.49451C28.1321 7.06594 27.7365 6.73627 27.231 6.5055C26.7145 6.27473 26.1101 6.15385 25.4178 6.15385H21.9013V7.86814H25.2859C25.7255 7.86814 26.0662 7.96704 26.2969 8.16484C26.5167 8.36264 26.6376 8.64836 26.6376 9C26.6376 9.36264 26.5167 9.63737 26.2969 9.83517C26.0662 10.033 25.7255 10.1209 25.2859 10.1209H21.9013V13.8462H24.0772V11.8022H25.264L26.6596 13.8462H28.9892L27.3299 11.4286ZM31.5658 13.8462V7.87912H29.2032V6.15385H36.0933V7.87912H33.7417V13.8462H31.5658Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M56.9021 14C56.0889 14 55.3526 13.8352 54.7043 13.4835C54.0559 13.1429 53.5504 12.6703 53.1768 12.0549C52.8032 11.4505 52.6273 10.7692 52.6273 10C52.6273 9.24176 52.8032 8.56044 53.1768 7.94505C53.5504 7.34066 54.0559 6.86813 54.7043 6.51648C55.3526 6.17582 56.0889 6 56.9021 6C57.7153 6 58.4405 6.17582 59.0889 6.51648C59.7372 6.86813 60.2427 7.34066 60.6163 7.94505C60.99 8.56044 61.1768 9.24176 61.1768 10C61.1768 10.7692 60.99 11.4505 60.6163 12.0549C60.2427 12.6703 59.7372 13.1429 59.0889 13.4835C58.4405 13.8352 57.7153 14 56.9021 14ZM56.9021 12.1978C57.2867 12.1978 57.6383 12.1099 57.957 11.9231C58.2647 11.7473 58.5174 11.4835 58.7043 11.1538C58.8801 10.8242 58.979 10.4396 58.979 10C58.979 9.57143 58.8801 9.18681 58.7043 8.85714C58.5174 8.52747 58.2647 8.26374 57.957 8.07692C57.6383 7.9011 57.2867 7.8022 56.9021 7.8022C56.5065 7.8022 56.1548 7.9011 55.8471 8.07692C55.5284 8.26374 55.2757 8.52747 55.0999 8.85714C54.9131 9.18681 54.8251 9.57143 54.8251 10C54.8251 10.4396 54.9131 10.8242 55.0999 11.1538C55.2757 11.4835 55.5284 11.7473 55.8471 11.9231C56.1548 12.1099 56.5065 12.1978 56.9021 12.1978ZM43.4208 7.49451C43.1351 7.06594 42.7395 6.73627 42.234 6.5055C41.7175 6.27473 41.1131 6.15385 40.4208 6.15385H36.9043V7.86814H40.2889C40.7285 7.86814 41.0691 7.96704 41.2999 8.16484C41.5197 8.36264 41.6406 8.64836 41.6406 9C41.6406 9.36264 41.5197 9.63737 41.2999 9.83517C41.0691 10.033 40.7285 10.1209 40.2889 10.1209H36.9043V13.8462H39.0801V11.8352H40.4208C41.1131 11.8352 41.7175 11.7253 42.234 11.4945C42.7395 11.2637 43.1351 10.9341 43.4208 10.5055C43.6955 10.0879 43.8384 9.58242 43.8384 9C43.8384 8.42858 43.6955 7.92308 43.4208 7.49451ZM50.317 11.4286C50.7895 11.1978 51.1632 10.8791 51.4269 10.4615C51.6906 10.044 51.8225 9.56044 51.8225 9C51.8225 8.42858 51.6796 7.92308 51.4049 7.49451C51.1192 7.06594 50.7236 6.73627 50.2181 6.5055C49.7016 6.27473 49.0972 6.15385 48.4049 6.15385H44.8884V7.86814H48.2731C48.7126 7.86814 49.0533 7.96704 49.284 8.16484C49.5038 8.36264 49.6247 8.64836 49.6247 9C49.6247 9.36264 49.5038 9.63737 49.284 9.83517C49.0533 10.033 48.7126 10.1209 48.2731 10.1209H44.8884V13.8462H47.0643V11.8022H48.2511L49.6467 13.8462H51.9763L50.317 11.4286Z" fill="#367BF6"/>
</svg>

);


export const IconVisa = ({ className }: React.HTMLAttributes<HTMLDivElement>) => (
  <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M45 35C45 37.209 43.209 39 41 39H7C4.791 39 3 37.209 3 35V13C3 10.791 4.791 9 7 9H41C43.209 9 45 10.791 45 13V35Z"
      fill="#1565C0"
    />
    <path
      d="M15.186 19L12.56 26.832C12.56 26.832 11.893 23.519 11.827 23.103C10.332 19.692 8.126 19.882 8.126 19.882L10.726 30V29.998H13.887L18.258 19H15.186ZM17.689 30H20.56L22.296 19H19.389L17.689 30ZM38.008 19H34.987L30.277 30H33.129L33.717 28.429H37.313L37.619 30H40.232L38.008 19ZM34.513 26.328L36.076 22.171L36.894 26.328H34.513ZM26.369 22.206C26.369 21.6 26.867 21.149 28.295 21.149C29.223 21.149 30.286 21.823 30.286 21.823L30.752 19.514C30.752 19.514 29.394 18.999 28.061 18.999C25.042 18.999 23.485 20.443 23.485 22.271C23.485 25.577 27.464 25.124 27.464 26.822C27.464 27.113 27.233 27.786 25.576 27.786C23.914 27.786 22.817 27.177 22.817 27.177L22.322 29.393C22.322 29.393 23.385 29.999 25.439 29.999C27.498 29.999 30.354 28.459 30.354 26.247C30.354 23.586 26.369 23.394 26.369 22.206Z"
      fill="white"
    />
    <path
      d="M12.212 24.945L11.246 20.197C11.246 20.197 10.809 19.168 9.673 19.168C8.537 19.168 5.233 19.168 5.233 19.168C5.233 19.168 10.894 20.84 12.212 24.945Z"
      fill="#FFC107"
    />
  </svg>
);

export const CustomIconFileUpload = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="83"
    height="68"
    viewBox="0 0 83 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M74.8086 33.4116C74.8086 42.0536 71.2788 49.8435 65.6189 55.4425C60.0808 60.9807 52.4125 64.3279 43.9531 64.3279C35.5546 64.3279 27.8864 60.9198 22.2874 55.4425C16.6275 49.8435 13.0977 42.0536 13.0977 33.4116C13.0977 16.3102 26.9126 2.49524 43.9531 2.49524C60.9936 2.49524 74.8086 16.3711 74.8086 33.4116Z"
      fill="#DBE2EB"
    />
    <path
      d="M78.005 21.6844C79.3831 21.6844 80.5002 20.5673 80.5002 19.1892C80.5002 17.8111 79.3831 16.694 78.005 16.694C76.6269 16.694 75.5098 17.8111 75.5098 19.1892C75.5098 20.5673 76.6269 21.6844 78.005 21.6844Z"
      fill="#DBE2EB"
    />
    <path
      d="M75.7822 3.4081C76.7233 3.4081 77.4862 2.64517 77.4862 1.70405C77.4862 0.762929 76.7233 0 75.7822 0C74.8411 0 74.0781 0.762929 74.0781 1.70405C74.0781 2.64517 74.8411 3.4081 75.7822 3.4081Z"
      fill="#DBE2EB"
    />
    <path
      d="M14.0712 13.0846C15.0124 13.0846 15.7753 12.3217 15.7753 11.3806C15.7753 10.4394 15.0124 9.67651 14.0712 9.67651C13.1301 9.67651 12.3672 10.4394 12.3672 11.3806C12.3672 12.3217 13.1301 13.0846 14.0712 13.0846Z"
      fill="#DBE2EB"
    />
    <path
      d="M3.66467 45.9485C5.41246 45.9485 6.82933 44.5316 6.82933 42.7838C6.82933 41.036 5.41246 39.6191 3.66467 39.6191C1.91687 39.6191 0.5 41.036 0.5 42.7838C0.5 44.5316 1.91687 45.9485 3.66467 45.9485Z"
      fill="#DBE2EB"
    />
    <path
      d="M67.3498 15.2106L64.8117 33.6466L61.6392 56.4267C60.8989 56.8505 60.0529 57.1684 59.2069 57.1684H22.6169C21.0306 57.1684 19.6558 56.6386 18.4926 55.791C18.1753 55.5791 17.8581 55.2612 17.5408 54.9434C16.2718 53.6719 15.4258 51.7647 15.4258 49.7516V10.3367C15.4258 8.53548 16.9063 7.15808 18.5983 7.15808H29.7022C30.4425 7.15808 31.1828 7.47594 31.8173 8.11167L35.4128 12.032C35.9416 12.5617 36.6818 12.8796 37.4221 12.8796H65.2347C66.5038 12.8796 67.4555 13.9391 67.3498 15.2106Z"
      fill="url(#paint0_linear)"
    />
    <g filter="url(#filter0_d)">
      <path
        d="M20.8184 53.1422L23.7794 18.919C23.8852 17.6476 24.9427 16.694 26.2117 16.694H68.3008C69.464 16.694 70.3101 17.6476 70.2043 18.8131L67.2433 47.9504L20.8184 53.1422Z"
        fill="url(#paint1_linear)"
      />
    </g>
    <g filter="url(#filter1_d)">
      <path
        d="M37.6331 49.4338L22.1934 53.0362L31.711 26.8655C32.134 25.7001 33.1915 24.9584 34.4605 24.9584H71.7908C73.1656 24.9584 74.1174 26.4417 73.4828 27.7132L63.3307 48.4802L37.6331 49.4338Z"
        fill="url(#paint2_linear)"
      />
    </g>
    <g filter="url(#filter2_d)">
      <path
        d="M77.0785 36.1894L62.9078 55.2612C62.5906 55.685 62.0618 56.1088 61.6388 56.4267C60.8985 56.8505 60.0525 57.1684 59.2065 57.1684H22.6165C21.0302 57.1684 19.6555 56.6386 18.4922 55.7909L31.2022 40.9646C32.532 39.4132 34.4734 38.5204 36.5167 38.5204H56.5627C57.6202 38.5204 58.6778 38.2026 59.5238 37.4609L63.5423 34.3882C63.9653 34.0704 64.3883 33.8585 64.8113 33.6466C65.3401 33.4346 65.9746 33.3287 66.5034 33.3287H75.598C77.0785 33.2227 77.9245 35.024 77.0785 36.1894Z"
        fill="url(#paint3_linear)"
      />
    </g>
    <path
      d="M53.9302 53.703C53.7216 54.5892 53.4088 55.5276 53.0439 56.3096C52.0534 58.2385 50.4894 59.7503 48.5606 60.7408C46.5795 61.7313 44.2336 62.1484 41.8876 61.6271C36.3616 60.4802 32.8166 55.0584 33.9635 49.5324C35.1105 44.0064 40.4801 40.4093 46.0061 41.6083C47.9871 42.0254 49.7075 43.0159 51.1672 44.3713C53.6174 46.8215 54.66 50.3665 53.9302 53.703Z"
      fill="white"
    />
    <g filter="url(#filter3_d)">
      <path
        d="M47.2041 50.7313H44.8582V48.3854C44.8582 47.9162 44.4933 47.4991 43.972 47.4991C43.5028 47.4991 43.0857 47.8641 43.0857 48.3854V50.7313H40.7398C40.2706 50.7313 39.8535 51.0963 39.8535 51.6176C39.8535 52.1389 40.2184 52.5038 40.7398 52.5038H43.0857V54.8498C43.0857 55.319 43.4506 55.736 43.972 55.736C44.4411 55.736 44.8582 55.3711 44.8582 54.8498V52.5038H47.2041C47.6733 52.5038 48.0904 52.1389 48.0904 51.6176C48.0904 51.0963 47.6733 50.7313 47.2041 50.7313Z"
        fill="url(#paint4_linear)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="6.81836"
        y="6.69397"
        width="69.3949"
        height="56.4482"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d"
        x="8.19336"
        y="14.9584"
        width="71.4903"
        height="48.0778"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d"
        x="3.49219"
        y="23.3242"
        width="78.9224"
        height="43.8441"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d"
        x="24.8535"
        y="37.4991"
        width="28.2369"
        height="28.2369"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="41.3959"
        y1="8.89538"
        x2="41.3959"
        y2="36.9657"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="45.4997"
        y1="15.8509"
        x2="45.4997"
        y2="53.5351"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="47.9218"
        y1="24.3089"
        x2="47.9218"
        y2="53.3389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="47.9581"
        y1="34.1525"
        x2="47.9581"
        y2="47.536"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="43.9726"
        y1="47.7853"
        x2="43.9726"
        y2="52.4086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);
export const CustomIconSave = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 0H6V4H10V0Z" fill="var(--color-primary-500)" />
    <path
      d="M15 0H12V5C12 5.26522 11.8946 5.51957 11.7071 5.70711C11.5196 5.89464 11.2652 6 11 6H5C4.73478 6 4.48043 5.89464 4.29289 5.70711C4.10536 5.51957 4 5.26522 4 5V0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V15C0 15.2652 0.105357 15.5196 0.292893 15.7071C0.48043 15.8946 0.734784 16 1 16H15C15.2652 16 15.5196 15.8946 15.7071 15.7071C15.8946 15.5196 16 15.2652 16 15V1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0ZM6 14H2V12H6V14Z"
      fill="#BFCCDA"
    />
  </svg>
);
export const CustomIconSaveOutline = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00037 7.40002C6.59512 7.40002 5.45593 8.53921 5.45593 9.94446C5.45593 11.3497 6.59512 12.4889 8.00037 12.4889C9.40563 12.4889 10.5448 11.3497 10.5448 9.94446C10.5448 8.53921 9.40563 7.40002 8.00037 7.40002ZM6.65593 9.94446C6.65593 9.20195 7.25786 8.60002 8.00037 8.60002C8.74288 8.60002 9.34481 9.20195 9.34481 9.94446C9.34481 10.687 8.74288 11.2889 8.00037 11.2889C7.25786 11.2889 6.65593 10.687 6.65593 9.94446Z"
      fill="#172A41"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2453 0.400024H2.55603C1.98151 0.400024 1.43081 0.629395 1.02613 1.03711C0.621433 1.44484 0.396243 1.99729 0.400448 2.5717L0.48138 13.4606C0.490031 14.6448 1.45279 15.6002 2.63708 15.6L13.4448 15.6C14.0164 15.6 14.5648 15.3732 14.9692 14.9688C15.3736 14.5644 15.6004 14.016 15.6004 13.4444V4.75492C15.6002 4.18335 15.373 3.63523 14.9689 3.23108L12.7693 1.03154C12.3652 0.627188 11.817 0.400024 11.2453 0.400024ZM2.55603 1.60002C2.30139 1.60002 2.05725 1.70169 1.87782 1.88246C1.69843 2.0632 1.59857 2.30809 1.60042 2.56278L1.68135 13.4516C1.68516 13.9765 2.11183 14.4001 2.63675 14.4H13.4448C13.6985 14.4 13.9415 14.2993 14.1206 14.1202C14.2997 13.9411 14.4004 13.6981 14.4004 13.4444V4.75533C14.4003 4.50195 14.2995 4.25879 14.1204 4.07962L11.9208 1.88006C11.8566 1.81583 11.7842 1.76165 11.706 1.71859V4.11113C11.7057 4.87182 11.0891 5.48863 10.3285 5.4889L5.66159 5.4889C4.9009 5.48863 4.28409 4.87203 4.28381 4.11134V1.60002H2.55603ZM10.506 4.11091V1.60002H5.48381V4.11091C5.48385 4.2092 5.56352 4.28887 5.6618 4.2889H10.328C10.4263 4.28887 10.506 4.2092 10.506 4.11091Z"
      fill="#172A41"
    />
  </svg>
);
export const CustomIconReference = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00027 1.99961L2 4C2 4.55229 1.55228 5 1 5C0.447715 5 0 4.55229 0 4V2C0 1.73066 0.0537905 1.47136 0.152155 1.23416C0.257891 0.979178 0.456933 0.791168 0.693293 0.693293C0.791167 0.456933 0.979177 0.257891 1.23416 0.152155C1.47136 0.0537906 1.73066 0 2 0H4C4.55228 0 5 0.447715 5 1C5 1.55228 4.55228 2 4 2L2.00027 1.99961ZM7 1C7 0.447715 7.44772 0 8 0H12C12.5523 0 13 0.447715 13 1C13 1.55228 12.5523 2 12 2H8C7.44772 2 7 1.55228 7 1ZM15 1C15 0.447715 15.4477 0 16 0H18C18.2693 0 18.5286 0.0537905 18.7658 0.152155C19.0208 0.257891 19.2088 0.456933 19.3067 0.693294C19.5431 0.791168 19.7421 0.979177 19.8478 1.23416C19.9462 1.47136 20 1.73066 20 2V4C20 4.55228 19.5523 5 19 5C18.4477 5 18 4.55228 18 4V2H16C15.4477 2 15 1.55228 15 1ZM19 7C19.5523 7 20 7.44772 20 8V12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12V8C18 7.44772 18.4477 7 19 7ZM1 7C1.55228 7 2 7.44772 2 8C2 8.55229 1.55228 9 1 9C0.447715 9 0 8.55229 0 8C0 7.44772 0.447715 7 1 7ZM19 15C19.5523 15 20 15.4477 20 16V18C20 18.2693 19.9462 18.5286 19.8478 18.7658C19.7421 19.0208 19.5431 19.2088 19.3067 19.3067C19.2088 19.5431 19.0208 19.7421 18.7658 19.8478C18.5286 19.9462 18.2693 20 18 20H16C15.4477 20 15 19.5523 15 19C15 18.4477 15.4477 18 16 18H18V16C18 15.4477 18.4477 15 19 15ZM11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19Z"
      fill="#BFCCDA"
    />
    <path
      d="M0 11C0 10.4477 0.447715 10 1 10H9C9.55228 10 10 10.4477 10 11V19C10 19.5523 9.55228 20 9 20H1C0.447716 20 0 19.5523 0 19V11Z"
      fill="var(--color-primary-500)"
    />
  </svg>
);

export const CustomIconEquipment = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8744 10.0001C16.5869 10.0001 17.1306 10.3313 9.63061 4.88134C9.56413 4.83292 9.50783 4.77187 9.46494 4.70169C9.42205 4.63151 9.39341 4.55357 9.38064 4.47232C9.36787 4.39107 9.37123 4.3081 9.39053 4.22814C9.40983 4.14819 9.44468 4.07282 9.49311 4.00634C9.54153 3.93986 9.60258 3.88357 9.67276 3.84068C9.74294 3.79779 9.82088 3.76914 9.90213 3.75637C9.98338 3.7436 10.0664 3.74696 10.1463 3.76626C10.2263 3.78556 10.3016 3.82042 10.3681 3.86884L17.2431 8.86884C17.3502 8.9464 17.43 9.05596 17.4709 9.18174C17.5119 9.30752 17.5118 9.44304 17.4708 9.56879C17.4298 9.69455 17.35 9.80406 17.2428 9.88156C17.1356 9.95906 17.0066 10.0006 16.8744 10.0001Z"
      fill="var(--color-primary-500)"
    />
    <path
      d="M10.0001 6.25002C7.60013 6.25002 6.81263 3.12502 8.12513 3.12502C8.29089 3.12502 8.44986 3.19087 8.56707 3.30808C8.68428 3.42529 8.75013 3.58426 8.75013 3.75002C8.7521 3.96896 8.81153 4.18353 8.92249 4.37227C9.03345 4.56102 9.19204 4.7173 9.38238 4.82549C9.57272 4.93369 9.78814 4.98998 10.0071 4.98876C10.226 4.98753 10.4408 4.92882 10.6299 4.8185C10.819 4.70818 10.9759 4.55013 11.0847 4.36015C11.1935 4.17018 11.2506 3.95495 11.2501 3.73601C11.2496 3.51707 11.1916 3.30209 11.0819 3.1126C10.9723 2.92311 10.8147 2.76575 10.6251 2.65627C10.2563 2.47259 9.9448 2.19142 9.72445 1.84325C9.50409 1.49509 9.38328 1.09323 9.37513 0.681274C9.37513 0.515514 9.44097 0.356543 9.55818 0.239333C9.67539 0.122122 9.83437 0.0562744 10.0001 0.0562744C10.1659 0.0562744 10.3249 0.122122 10.4421 0.239333C10.5593 0.356543 10.6251 0.515514 10.6251 0.681274C10.6341 0.865992 10.6928 1.04485 10.7951 1.19889C10.8975 1.35294 11.0396 1.47643 11.2064 1.55627C11.6943 1.82291 12.0793 2.24456 12.3007 2.75456C12.5221 3.26456 12.5672 3.83381 12.4288 4.37229C12.2904 4.91077 11.9765 5.38776 11.5366 5.72783C11.0968 6.06791 10.5561 6.25165 10.0001 6.25002Z"
      fill="var(--color-primary-500)"
    />
    <path
      d="M3.12528 10.0001C2.99302 10.0006 2.86401 9.95906 2.75683 9.88156C2.64964 9.80406 2.56981 9.69455 2.52882 9.56879C2.48783 9.44304 2.48779 9.30752 2.52871 9.18174C2.56963 9.05596 2.6494 8.9464 2.75653 8.86884L9.63153 3.86884C9.69802 3.82042 9.77338 3.78556 9.85334 3.76626C9.93329 3.74696 10.0163 3.7436 10.0975 3.75637C10.1788 3.76914 10.2567 3.79779 10.3269 3.84068C10.3971 3.88357 10.4581 3.93986 10.5065 4.00634C10.555 4.07282 10.5898 4.14819 10.6091 4.22814C10.6284 4.3081 10.6318 4.39107 10.619 4.47232C10.6062 4.55357 10.5776 4.63151 10.5347 4.70169C10.4918 4.77187 10.4355 4.83292 10.369 4.88134C2.94403 10.2813 3.41903 10.0001 3.12528 10.0001Z"
      fill="var(--color-primary-500)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 19.75H2.25C1.91848 19.75 1.60054 19.6183 1.36612 19.3839C1.1317 19.1495 1 18.8315 1 18.5V17.25V9.75C1 9.41848 1.1317 9.10054 1.36612 8.86612C1.60054 8.6317 1.91848 8.5 2.25 8.5H17.25C17.5815 8.5 17.8995 8.6317 18.1339 8.86612C18.3683 9.10054 18.5 9.41848 18.5 9.75V18.5C18.5 18.8315 18.3683 19.1495 18.1339 19.3839C17.8995 19.6183 17.5815 19.75 17.25 19.75ZM5.18306 17.3169C5.30027 17.4342 5.45924 17.5 5.625 17.5C5.79076 17.5 5.94973 17.4342 6.06694 17.3169C6.18415 17.1997 6.25 17.0408 6.25 16.875V11.875C6.25 11.7092 6.18415 11.5503 6.06694 11.4331C5.94973 11.3158 5.79076 11.25 5.625 11.25C5.45924 11.25 5.30027 11.3158 5.18306 11.4331C5.06585 11.5503 5 11.7092 5 11.875V16.875C5 17.0408 5.06585 17.1997 5.18306 17.3169ZM9.55806 17.3169C9.67527 17.4342 9.83424 17.5 10 17.5C10.1658 17.5 10.3247 17.4342 10.4419 17.3169C10.5592 17.1997 10.625 17.0408 10.625 16.875V11.875C10.625 11.7092 10.5592 11.5503 10.4419 11.4331C10.3247 11.3158 10.1658 11.25 10 11.25C9.83424 11.25 9.67527 11.3158 9.55806 11.4331C9.44085 11.5503 9.375 11.7092 9.375 11.875V16.875C9.375 17.0408 9.44085 17.1997 9.55806 17.3169ZM14.375 17.5C14.2092 17.5 14.0503 17.4342 13.9331 17.3169C13.8158 17.1997 13.75 17.0408 13.75 16.875V11.875C13.75 11.7092 13.8158 11.5503 13.9331 11.4331C14.0503 11.3158 14.2092 11.25 14.375 11.25C14.5408 11.25 14.6997 11.3158 14.8169 11.4331C14.9342 11.5503 15 11.7092 15 11.875V16.875C15 17.0408 14.9342 17.1997 14.8169 17.3169C14.6997 17.4342 14.5408 17.5 14.375 17.5Z"
      fill="#BFCCDA"
    />
  </svg>
);

export const CustomIconTruck = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0049 16.4277H7.34375"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0095 11.0054H17.508C17.2318 11.0054 17.0078 10.7815 17.0078 10.5052V7.00375H20.5091"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5656 15.4466C17.9948 15.8757 18.1232 16.5212 17.891 17.0819C17.6588 17.6427 17.1116 18.0083 16.5046 18.0083C15.8977 18.0083 15.3505 17.6428 15.1182 17.082C14.8859 16.5213 15.0143 15.8759 15.4434 15.4467L15.4435 15.4465C16.0295 14.8606 16.9796 14.8606 17.5656 15.4465V15.4465"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 2.00167H9.00333"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00391 2.00166C9.55642 2.00166 10.0043 2.44956 10.0043 3.00208"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0041 3.00209V9.00459"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.56172 15.4466C3.99092 15.8757 4.11933 16.5211 3.88709 17.0819C3.65485 17.6427 3.10769 18.0083 2.50074 18.0083C1.89379 18.0083 1.34659 17.6428 1.1143 17.082C0.882005 16.5213 1.01036 15.8758 1.43952 15.4467L1.43982 15.4464C1.72121 15.165 2.10286 15.0069 2.5008 15.0069C2.89874 15.007 3.28036 15.1651 3.5617 15.4465V15.4465"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.7375 15.4466C7.1667 15.8757 7.29512 16.5211 7.06287 17.0819C6.83063 17.6427 6.28347 18.0083 5.67652 18.0083C5.06957 18.0083 4.52238 17.6428 4.29008 17.082C4.05779 16.5213 4.18614 15.8758 4.6153 15.4467L4.6156 15.4464C4.89699 15.165 5.27864 15.0069 5.67658 15.0069C6.07452 15.007 6.45614 15.1651 6.73748 15.4465V15.4465"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0011 16.5077H20.0068C20.5593 16.5077 21.0072 16.0598 21.0072 15.5073V8.47665C21.0072 8.16593 20.9349 7.85949 20.7959 7.5816L19.5588 5.1083C19.2199 4.43058 18.5271 4.0025 17.7693 4.0025H13.0039"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 12.0058H13.005V2.00166"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomIconBilling = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0023 8.99958H17.0031C18.1847 8.91566 19.0778 7.89491 19.004 6.71263V3.2832C19.0778 2.10092 18.1847 1.08017 17.0031 0.996246H2.99729C1.81568 1.08017 0.922633 2.10092 0.996453 3.2832V6.71363C0.922648 7.89572 1.81583 8.91618 2.99729 8.99958H4.99812"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3365 17.0029L11.6698 18.0033L10.0021 17.0029L8.33439 18.0033L6.66769 17.0029L5 18.0033V4.99792H15.0042V18.0033L13.3365 17.0029Z"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 14.0017H12.0017"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7513 9.01257L9.73141 11.0314L8.75 10.053"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomIconMapMarker = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6569 3.35098V3.35098C18.7811 6.48993 18.7811 11.5636 15.6569 14.7025V14.7025L12.345 18.0254C11.056 19.3205 8.96113 19.3254 7.666 18.0364L7.655 18.0254L4.34313 14.7025C1.21898 11.5635 1.21895 6.48998 4.34307 3.35098V3.35098C7.45255 0.226779 12.5059 0.214847 15.6301 3.32433L15.6568 3.35098H15.6569Z"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 8.62875V11C13 11.5523 12.5523 12 12 12H8C7.44772 12 7 11.5523 7 11V8.57113C7 8.26734 7.1381 7.98002 7.37532 7.79025L9.33932 6.21912C9.70453 5.92696 10.2235 5.92696 10.5887 6.21912L12.6247 7.84787C12.8619 8.03764 13 8.32496 13 8.62875Z"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CustomIconBuilding = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4.5V7"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 10V8C7.5 7.44772 7.94772 7 8.5 7H11.5C12.0523 7 12.5 7.44772 12.5 8V10"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 18.8997V11C5 10.4477 5.44772 10 6 10H14C14.5523 10 15 10.4477 15 11V18.8997"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="5"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 13H12.5"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 16H12.5"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomIconDonoutChart = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="15" stroke="#DBE2EB" strokeWidth="5" />
    <path
      d="M31.1652 25.1887C32.4126 22.9043 33.0441 20.3346 32.9976 17.7323C32.9512 15.1299 32.2284 12.5844 30.9002 10.346C29.5721 8.10753 27.6844 6.25317 25.4226 4.96521C23.1608 3.67725 20.6028 3 18 3"
      stroke="var(--color-primary-500)"
      strokeWidth="5"
    />
  </svg>
);

export const CustomIconAddUser = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <circle cx="15" cy="15.5" r="15" fill="#DBE2EB" />
      <path
        d="M15.1273 9.1618C16.0097 10.0442 16.0097 11.4749 15.1273 12.3573C14.2449 13.2397 12.8142 13.2397 11.9318 12.3573C11.0494 11.4749 11.0494 10.0442 11.9318 9.1618C12.8142 8.2794 14.2449 8.2794 15.1273 9.1618"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.705 19.5H9.55926C9.25055 19.5 9 19.2098 9 18.8522V18.2044C9 16.2448 11.2102 14.9706 13.474 14.9706C13.9323 14.9706 14.388 15.023 14.8235 15.1228"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 25.5C16.239 25.5 14 23.262 14 20.5C14 17.796 16.3 15.497 19.004 15.5C21.764 15.502 24 17.74 24 20.5C24 23.261 21.762 25.5 19 25.5Z"
        fill="var(--color-primary-500)"
      />
      <path
        d="M19 18.5V22.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21 20.5H17"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CustomIconNotes = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0003 8.99955H17.0012C18.1828 8.91563 19.0758 7.89487 19.002 6.7126V3.28317C19.0758 2.10089 18.1828 1.08013 17.0012 0.996216H2.99533C1.81373 1.08013 0.92068 2.10089 0.9945 3.28317V6.7136C0.920695 7.89569 1.81388 8.91615 2.99533 8.99955H4.99617"
      stroke="#687D96"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3326 17.0029L11.6659 18.0033L9.99818 17.0029L8.33048 18.0033L6.66379 17.0029L4.99609 18.0033V4.99792H15.0003V18.0033L13.3326 17.0029Z"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99805 14.0017H11.9997"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7493 9.01257L9.72946 11.0314L8.74805 10.053"
      stroke="var(--color-primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomIconAlert = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="50"
    height="41"
    viewBox="0 0 50 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.828345 33.4867L20.5954 2.2016C22.7469 -0.733866 27.2517 -0.733866 29.4032 2.2016L49.1703 33.4867C51.2546 36.2917 49.1703 40.2709 45.6068 40.2709H4.45903C0.828345 40.2056 -1.25594 36.2917 0.828345 33.4867Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M24.9995 10.2109C23.1159 10.2109 21.6509 11.8668 21.7904 13.8106L22.8369 25.4734C22.9066 26.6253 23.8833 27.5612 24.9995 27.5612C26.1157 27.5612 27.0924 26.6253 27.1621 25.4734L28.2086 13.8106C28.3481 11.7948 26.8831 10.2109 24.9995 10.2109Z"
      fill="white"
    />
    <path
      d="M24.9997 29.7209C23.6045 29.7209 22.4883 30.8728 22.4883 32.3127C22.4883 33.7525 23.6045 34.9044 24.9997 34.9044C26.395 34.9044 27.5112 33.7525 27.5112 32.3127C27.5112 30.8728 26.395 29.7209 24.9997 29.7209Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-0.0228992"
        y1="21.1943"
        x2="50.0091"
        y2="21.1943"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIconMessage = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="132"
    height="132"
    viewBox="0 0 132 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M69.4282 109.689C96.9016 109.689 119.175 87.4162 119.175 59.8446C119.175 32.2731 96.9016 10 69.4282 10C41.9547 10 19.6816 32.2731 19.6816 59.8446C19.6816 87.4162 41.9547 109.689 69.4282 109.689Z"
      fill="#EAEEF9"
    />
    <path
      d="M124.866 44.2435C127.087 44.2435 128.889 42.4424 128.889 40.2206C128.889 37.9989 127.087 36.1978 124.866 36.1978C122.644 36.1978 120.843 37.9989 120.843 40.2206C120.843 42.4424 122.644 44.2435 124.866 44.2435Z"
      fill="#EAEEF9"
    />
    <path
      d="M108.247 21.4947C109.765 21.4947 110.995 20.2647 110.995 18.7473C110.995 17.23 109.765 16 108.247 16C106.73 16 105.5 17.23 105.5 18.7473C105.5 20.2647 106.73 21.4947 108.247 21.4947Z"
      fill="#EAEEF9"
    />
    <path
      d="M16.2473 47.0889C17.7647 47.0889 18.9947 45.8589 18.9947 44.3416C18.9947 42.8243 17.7647 41.5942 16.2473 41.5942C14.73 41.5942 13.5 42.8243 13.5 44.3416C13.5 45.8589 14.73 47.0889 16.2473 47.0889Z"
      fill="#EAEEF9"
    />
    <path
      d="M86.5002 31.0396C103.438 31.0396 117.102 43.3579 117.102 58.5015C117.102 67.2035 112.585 75.0013 105.471 80.0869V91.5011C105.471 93.0833 103.664 93.8744 102.535 92.9703L92.8237 85.3985C90.7911 85.7375 88.7586 85.9635 86.6131 85.9635C69.6751 85.9635 56.0117 73.6452 56.0117 58.5015C56.0117 43.3579 69.6751 31.0396 86.5002 31.0396Z"
      fill="#CBD4E0"
    />
    <g filter="url(#filter0_d)">
      <path
        d="M56.5765 29.6836C37.7188 29.6836 22.4746 43.3581 22.4746 60.1969C22.4746 69.916 27.556 78.6179 35.4604 84.1555V96.8129C35.4604 98.5081 37.3801 99.5252 38.7351 98.3951L49.5754 90.0322C51.8338 90.4842 54.0922 90.7102 56.4636 90.7102C75.3212 90.7102 90.5654 77.0357 90.5654 60.1969C90.5654 43.3581 75.3212 29.6836 56.5765 29.6836Z"
        fill="url(#paint0_linear)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0.474609"
        y="18.6836"
        width="112.091"
        height="113.189"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="56.4978"
        y1="28.0832"
        x2="56.4978"
        y2="99.6183"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIconUploadDocument = ({ className }: IClassNameProps) => (
  <svg
    width="128"
    height="127"
    viewBox="0 0 128 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M63.8502 107.5C93.5502 107.5 117.75 83.4 117.75 53.8C117.65 24.1 93.5502 0 63.8502 0C34.0502 0 9.9502 24.1 9.9502 53.7C9.9502 83.4 34.0502 107.5 63.8502 107.5Z"
      fill="#EAEEF9"
    />
    <path
      d="M119.05 35C121.315 35 123.15 33.1644 123.15 30.9C123.15 28.6357 121.315 26.8 119.05 26.8C116.786 26.8 114.95 28.6357 114.95 30.9C114.95 33.1644 116.786 35 119.05 35Z"
      fill="#EAEEF9"
    />
    <path
      d="M125.05 18.9999C126.596 18.9999 127.85 17.7463 127.85 16.1999C127.85 14.6535 126.596 13.3999 125.05 13.3999C123.504 13.3999 122.25 14.6535 122.25 16.1999C122.25 17.7463 123.504 18.9999 125.05 18.9999Z"
      fill="#EAEEF9"
    />
    <path
      d="M5.35039 89.7999C8.22227 89.7999 10.5504 87.4718 10.5504 84.5999C10.5504 81.728 8.22227 79.3999 5.35039 79.3999C2.47851 79.3999 0.150391 81.728 0.150391 84.5999C0.150391 87.4718 2.47851 89.7999 5.35039 89.7999Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_3966:351255)">
      <path
        d="M93.1879 34.4448L93.8855 90.5993C93.8855 92.5177 92.316 94 90.3976 94H35.6382C33.7199 94 32.1504 92.4305 32.1504 90.5993V18.4007C32.1504 16.4823 33.7199 15 35.6382 15H75.3126L93.1879 34.4448Z"
        fill="url(#paint0_linear_3966:351255)"
      />
    </g>
    <path
      d="M58.3383 82H57.2164C56.9725 82 56.7773 81.7727 56.7773 81.5C56.7773 81.2273 56.9725 81 57.2164 81H58.3383C58.5822 81 58.7773 81.2273 58.7773 81.5C58.7773 81.8182 58.5822 82 58.3383 82Z"
      fill="#CED7E2"
    />
    <path
      d="M52.0668 82H41.4879C41.0931 82 40.7773 81.7727 40.7773 81.5C40.7773 81.2273 41.0931 81 41.4879 81H52.0668C52.4616 81 52.7773 81.2273 52.7773 81.5C52.7773 81.8182 52.4616 82 52.0668 82Z"
      fill="#D5DDEA"
    />
    <path
      d="M67.6642 27H41.8905C41.2911 27 40.7773 26.5385 40.7773 26C40.7773 25.4615 41.2911 25 41.8905 25H67.6642C68.2636 25 68.7773 25.4615 68.7773 26C68.7773 26.5385 68.2636 27 67.6642 27Z"
      fill="#D5DDEA"
    />
    <path
      d="M51.7561 33H41.8837C41.288 33 40.7773 32.5385 40.7773 32C40.7773 31.4615 41.288 31 41.8837 31H51.671C52.2667 31 52.7773 31.4615 52.7773 32C52.7773 32.5385 52.2667 33 51.7561 33Z"
      fill="#D5DDEA"
    />
    <path
      d="M75.5234 15V30.9641C75.5234 33.2063 77.4551 35 79.6503 35L93.1503 34.5"
      fill="#D5DDEA"
    />
    <path
      d="M54.0473 43.514C56.5767 41.8926 59.5601 40.9846 62.7381 40.9846C71.4289 40.9846 78.4983 47.9892 78.4983 56.68C78.4983 65.3708 71.4289 72.3753 62.7381 72.3753C54.0473 72.3753 46.9779 65.3708 46.9779 56.68C46.8482 51.1671 49.7019 46.3677 54.0473 43.514Z"
      fill="url(#paint1_linear_3966:351255)"
    />
    <path
      d="M63.8713 49.5072L68.3796 54.4348C68.9099 55.0145 68.9099 56.029 68.3796 56.6087C67.8492 57.1884 66.921 57.1884 66.3243 56.6087L64.2691 54.4348V62.4058C64.2691 63.2754 63.6061 64 62.8105 64C62.0149 64 61.3519 63.2754 61.3519 62.4058V54.4348L59.2967 56.6087C58.7663 57.1884 57.8381 57.1884 57.2414 56.6087C56.9099 56.2464 56.7773 55.8841 56.7773 55.5217C56.7773 55.1594 56.9099 54.6522 57.2414 54.4348L61.7497 49.5072C61.9486 49.2899 62.4127 49 62.7442 49C63.0757 49 63.6724 49.1449 63.8713 49.5072Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_3966:351255"
        x="10.1504"
        y="4"
        width="105.735"
        height="123"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3966:351255"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3966:351255"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3966:351255"
        x1="62.9978"
        y1="13.1727"
        x2="62.9978"
        y2="94.8517"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3966:351255"
        x1="62.7385"
        y1="42.0751"
        x2="62.7385"
        y2="59.6944"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B0BACC" />
        <stop offset="1" stop-color="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIcon404_1 = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    viewBox="0 0 817 252"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".5"
      d="M816.35 251.184H.373c22.053-19.765 54.285-39.53 91.607-54.353 20.357-7.412 44.106-17.294 67.856-22.235 71.25-19.765 157.767-32.118 249.374-32.118 110.267 0 212.052 17.294 290.087 44.471 27.143 9.882 50.893 19.764 71.25 32.117 18.66 9.883 33.928 19.765 45.803 32.118Z"
      fill="url(#a)"
    />
    <path
      opacity=".3"
      d="M171.133 186.547c1.069 10.035-16.418 22.046-36.661 24.202-20.242 2.156-38.002-4.409-40.757-14.264 19.708-7.174 42.611-16.379 65.871-22.239 7.104 2.626 11.012 7.284 11.547 12.301Z"
      fill="url(#b)"
    />
    <path
      opacity=".3"
      d="M314.2 179.478c27.17 0 49.196-5.271 49.196-11.773s-22.026-11.773-49.196-11.773c-27.17 0-49.196 5.271-49.196 11.773s22.026 11.773 49.196 11.773Z"
      fill="url(#c)"
    />
    <path
      opacity=".3"
      d="M579.383 178.513c.557-8.342-20.968-16.548-48.079-18.329-27.11-1.782-49.539 3.536-50.097 11.878-.558 8.342 20.968 16.548 48.078 18.329 27.111 1.782 49.54-3.537 50.098-11.878Z"
      fill="url(#d)"
    />
    <path
      opacity=".3"
      d="M766.157 216.412c-6.741-.777-14.836-.517-24.754-3.354-26.772-4.78-47.717-15.661-46.753-24.015.192-1.671.192-1.671 2.07-3.147 26.194 9.793 50.002 19.264 69.437 30.516Z"
      fill="url(#e)"
    />
    <path
      d="M292.16 116.05v33.638h-20.357v31.956h-39.017v-31.956h-84.821v-38.683L226 3.363h45.803V116.05h20.357Zm-57.678-68.957-49.196 68.957h49.196V47.093Z"
      fill="url(#f)"
    />
    <path
      d="M414.302 185.009c-40.714 0-76.339-35.32-76.339-92.505C337.963 35.32 373.588 0 414.302 0s76.339 35.32 76.339 92.504c1.696 55.503-33.929 92.505-76.339 92.505Zm0-35.32c18.66 0 39.017-18.501 39.017-58.867 0-38.683-18.66-58.866-39.017-58.866-18.661 0-39.018 18.5-39.018 58.866 1.697 40.366 20.357 58.867 39.018 58.867Z"
      fill="url(#g)"
    />
    <path
      d="M684.029 116.05v33.638h-20.357v31.956h-39.017v-31.956h-84.821v-38.683L617.869 3.363h44.107V116.05h22.053Zm-59.374-68.957-49.196 68.957h49.196V47.093Z"
      fill="url(#h)"
    />
    <path
      d="M276.881 116.051v33.637h-20.357v31.957h-39.018v-31.957h-84.82v-38.683L210.721 3.364h44.107V116.05h22.053Zm-57.678-68.958-49.196 68.958h49.196V47.093Z"
      fill="url(#i)"
    />
    <path
      d="M399.022 185.009c-40.714 0-76.338-35.32-76.338-92.505C322.684 35.32 358.308 0 399.022 0c40.714 0 76.339 35.32 76.339 92.504 1.697 55.503-33.928 92.505-76.339 92.505Zm0-35.32c18.661 0 39.018-18.501 39.018-58.866 0-38.684-18.661-58.867-39.018-58.867-18.66 0-39.017 18.501-39.017 58.867 1.696 40.365 20.357 58.866 39.017 58.866Z"
      fill="url(#j)"
    />
    <path
      d="M668.75 116.051v33.637h-20.357v31.957h-39.017v-31.957h-84.821v-38.683L602.59 3.364h44.107V116.05h22.053Zm-59.374-68.958-49.197 68.958h49.197V47.093Z"
      fill="url(#k)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="408.362"
        y1="142.478"
        x2="408.362"
        y2="251.184"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B6BFD7" />
        <stop offset="1" stop-color="#838DA7" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="131.039"
        y1="178.462"
        x2="133.039"
        y2="197.236"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B0BACC" />
        <stop offset="1" stop-color="#969EAE" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="314.208"
        y1="156.75"
        x2="314.208"
        y2="169.966"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B0BACC" />
        <stop offset="1" stop-color="#969EAE" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="484.618"
        y1="172.284"
        x2="539.718"
        y2="175.967"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B0BACC" />
        <stop offset="1" stop-color="#969EAE" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="732.027"
        y1="190.758"
        x2="730.572"
        y2="203.367"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B0BACC" />
        <stop offset="1" stop-color="#969EAE" />
      </linearGradient>
      <linearGradient
        id="f"
        x1="220.074"
        y1="9.557"
        x2="220.074"
        y2="109.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D6DCE6" />
        <stop offset="1" stop-color="#C4CBDA" />
      </linearGradient>
      <linearGradient
        id="g"
        x1="414.343"
        y1="6.427"
        x2="414.343"
        y2="110.27"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D6DCE6" />
        <stop offset="1" stop-color="#C4CBDA" />
      </linearGradient>
      <linearGradient
        id="h"
        x1="611.943"
        y1="9.557"
        x2="611.943"
        y2="109.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D6DCE6" />
        <stop offset="1" stop-color="#C4CBDA" />
      </linearGradient>
      <linearGradient
        id="i"
        x1="204.795"
        y1="9.557"
        x2="204.795"
        y2="109.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EAEEF5" />
        <stop offset="1" stop-color="#D4DAE4" />
      </linearGradient>
      <linearGradient
        id="j"
        x1="399.064"
        y1="6.427"
        x2="399.064"
        y2="110.271"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EAEEF5" />
        <stop offset="1" stop-color="#D4DAE4" />
      </linearGradient>
      <linearGradient
        id="k"
        x1="596.664"
        y1="9.557"
        x2="596.664"
        y2="109.624"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EAEEF5" />
        <stop offset="1" stop-color="#D4DAE4" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomIconTruckMaintain = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    viewBox="0 0 239 131"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M78.01 128.376c-9.159 0-16.584-8.258-16.584-18.444 0-10.187 7.425-18.445 16.585-18.445s16.585 8.258 16.585 18.445c0 10.186-7.426 18.444-16.585 18.444Z"
      fill="#1C3754"
    />
    <path
      d="M75.058 121.244h2.954v7.132h-2.954v-7.132ZM204.333 128.376c-9.16 0-16.585-8.258-16.585-18.444 0-10.187 7.425-18.445 16.585-18.445s16.585 8.258 16.585 18.445c0 10.186-7.425 18.444-16.585 18.444Z"
      fill="#1C3754"
    />
    <path d="M199.329 117.309h4.771v11.067h-4.771v-11.067Z" fill="#1C3754" />
    <path
      d="M14.172 7.624v79.19H170.48V12.297C170.48 5.41 165.482 0 159.121 0H21.215c-3.862 0-7.043 3.443-7.043 7.624Z"
      fill="url(#a)"
    />
    <path
      opacity=".7"
      d="M120.042 26.315h20.901v65.172h-20.901V26.315Z"
      fill="url(#b)"
    />
    <path
      d="M.087 7.624v79.19h120.866V12.297C120.953 5.41 115.955 0 109.593 0H7.13C3.267 0 .087 3.443.087 7.624Z"
      fill="#EAEEF9"
    />
    <path
      d="M.087 7.624v79.19h120.866V12.297C120.953 5.41 115.955 0 109.593 0H7.13C3.267 0 .087 3.443.087 7.624Z"
      fill="url(#c)"
    />
    <path
      d="M74.833 128.376c-9.16 0-16.585-8.258-16.585-18.444 0-10.187 7.425-18.445 16.585-18.445s16.585 8.258 16.585 18.445c0 10.186-7.425 18.444-16.585 18.444ZM199.106 128.376c-9.159 0-16.585-8.258-16.585-18.444 0-10.187 7.426-18.445 16.585-18.445 9.16 0 16.585 8.258 16.585 18.445 0 10.186-7.425 18.444-16.585 18.444Z"
      fill="#112133"
    />
    <path
      d="M55.52 86.568v23.609h179.709c1.817 0 3.408-1.721 3.408-3.689V78.944c0-3.935-1.136-7.624-3.181-10.82L206.83 22.38h-59.752l27.263 64.188H55.519Z"
      fill="#EAEEF9"
    />
    <path
      d="M.085 86.568v23.609h193.341V79.682c0-4.427-1.136-8.854-3.635-12.543l-26.355-42.054c-1.136-1.721-2.953-2.951-4.998-2.951h-25.9c-1.363 0-2.272.984-2.272 2.46v61.974H.085Z"
      fill="#CAD1E0"
    />
    <path
      opacity=".4"
      d="M52.793 86.568h39.531v19.92H52.793v-19.92Z"
      fill="url(#d)"
    />
    <path
      d="M15.08 106.488c1.362-10.083 9.314-17.953 18.856-17.953 9.542 0 17.494 7.87 18.857 17.953h86.333c1.591-10.083 9.542-17.953 19.312-17.953 9.769 0 17.948 7.87 19.311 17.953h60.888v.246c0 1.968-1.591 3.689-3.408 3.689H.312v-3.689h14.767v-.246Z"
      fill="#ACB7CF"
    />
    <path
      d="M233.64 92.224c-1.757 0-3.181-2.642-3.181-5.902 0-3.26 1.424-5.902 3.181-5.902 1.756 0 3.18 2.642 3.18 5.902 0 3.26-1.424 5.902-3.18 5.902ZM202.056 92.224c-1.757 0-3.181-2.642-3.181-5.902 0-3.26 1.424-5.902 3.181-5.902 1.756 0 3.18 2.642 3.18 5.902 0 3.26-1.424 5.902-3.18 5.902Z"
      fill="#4C5463"
    />
    <path
      d="M210.693 101.324h14.995c1.59 0 2.726-1.476 2.726-2.951V84.355c0-1.722-1.363-2.952-2.726-2.952h-14.995c-1.59 0-2.726 1.476-2.726 2.952v14.018c0 1.721 1.136 2.951 2.726 2.951Z"
      fill="#CAD1E0"
    />
    <path
      d="m168.435 27.052 9.542 15.002 6.816 10.821 8.633 13.28h36.578l-3.862-5.902-3.181-4.918-3.181-4.919-6.361-9.837-8.633-13.527h-36.351ZM134.583 29.266v36.89h48.392l-23.174-37.628a1.24 1.24 0 0 0-1.136-.738h-22.719c-.682 0-1.363.738-1.363 1.476Z"
      fill="#fff"
    />
    <path
      d="M141.171 75.747h-5.452c-.455 0-.909-.492-.909-.984s.454-.984.909-.984h5.452c.455 0 .909.492.909.984 0 .738-.454.984-.909.984Z"
      fill="#4C5463"
    />
    <path
      d="M145.489 110.177c.228 10.084 7.725 18.199 17.04 18.199s16.812-8.115 17.039-18.199h-34.079Z"
      fill="#112133"
    />
    <path d="M157.983 111.653h4.544v16.969h-4.544v-16.969Z" fill="#112133" />
    <path
      d="M158.666 128.376c-9.411 0-17.04-8.258-17.04-18.444 0-10.187 7.629-18.445 17.04-18.445 9.41 0 17.039 8.258 17.039 18.445 0 10.186-7.629 18.444-17.039 18.444Z"
      fill="#1C3754"
    />
    <path
      d="M158.667 118.539c-4.391 0-7.951-3.854-7.951-8.608 0-4.753 3.56-8.607 7.951-8.607 4.392 0 7.952 3.854 7.952 8.607 0 4.754-3.56 8.608-7.952 8.608ZM21.666 110.177c.227 10.084 7.497 18.199 16.585 18.199 9.088 0 16.358-8.115 16.585-18.199h-33.17Z"
      fill="#112133"
    />
    <path d="M34.163 120.753h4.089v7.623h-4.09v-7.623Z" fill="#112133" />
    <path
      d="M34.163 128.376c-9.16 0-16.585-8.258-16.585-18.444 0-10.187 7.425-18.445 16.585-18.445s16.585 8.258 16.585 18.445c0 10.186-7.425 18.444-16.585 18.444Z"
      fill="#1C3754"
    />
    <path
      d="M34.164 118.539c-4.266 0-7.724-3.854-7.724-8.608 0-4.753 3.458-8.607 7.724-8.607s7.725 3.854 7.725 8.607c0 4.754-3.459 8.608-7.725 8.608Z"
      fill="#112133"
    />
    <path d="M88.918 94.438h45.666v7.132H88.918v-7.132Z" fill="#DAE1ED" />
    <path d="M89.826 101.324h43.848v29.266H89.826v-29.266Z" fill="#DAE1ED" />
    <path
      d="M120.498 94.438v36.152h13.177v-29.266h.909v-6.886h-14.086Z"
      fill="#fff"
    />
    <path
      opacity=".4"
      d="M105.276 94.438h4.089v36.152h-4.089V94.438Z"
      fill="#fff"
    />
    <path
      opacity=".15"
      d="M88.918 94.438v6.886h.91v5.41l8.632-4.426 1.591-.984 5.225-2.705 4.09-1.968 2.499-1.475 1.59-.738H88.918Z"
      fill="#4C5463"
    />
    <path d="M89.826 101.324h43.848v.734H89.826v-.734Z" fill="#ACB7CF" />
    <path
      d="M80.739 58.04h45.665v7.132H80.739V58.04ZM81.873 65.172h43.848v29.266H81.872V65.172Z"
      fill="#DAE1ED"
    />
    <path
      d="M112.318 58.04v36.398h13.405V65.172h.681V58.04h-14.086Z"
      fill="#fff"
    />
    <path opacity=".4" d="M97.1 58.04h4.089v36.152H97.1V58.04Z" fill="#fff" />
    <path d="M81.873 65.172h43.848v.734H81.872v-.734Z" fill="#ACB7CF" />
    <path
      d="M86.189 42.546c1.59 1.476 2.045 3.935.682 5.903l-.682.737L68.014 64.68c-1.59 1.476-3.863.984-5.226-.738-.454-.737-.681-1.475-.681-2.459v-5.902H25.756c-.682 0-1.136-.492-1.136-1.23V37.628c0-.738.454-1.23 1.136-1.23h36.35v-5.902c0-2.214 1.591-3.935 3.636-3.935.908 0 1.59.246 2.272.738l18.175 15.247Z"
      fill="url(#e)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="98.207"
        y1="-1.164"
        x2="88.5"
        y2="67.122"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#83A6FF" />
        <stop offset="1" stop-color="#5A78FF" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="130.425"
        y1="26.206"
        x2="130.425"
        y2="91.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".003" stop-color="#0F2F73" stop-opacity="0" />
        <stop offset="1" stop-color="#0A1D47" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="-2.495"
        y1="70.466"
        x2="133.848"
        y2="22.408"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#83A6FF" />
        <stop offset="1" stop-color="#5A78FF" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="63.841"
        y1="96.924"
        x2="100.348"
        y2="95.727"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".003" stop-color="#0F2F73" stop-opacity="0" />
        <stop offset="1" stop-color="#0A1D47" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="87.755"
        y1="45.88"
        x2="24.467"
        y2="45.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
export const CustomIconSpreadSheet = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9.59999L5.20001 8.39999V17.2668C5.20001 17.6717 5.52828 18 5.93321 18H17.6668C18.0717 18 18.4 17.6717 18.4 17.2668V14L12 9.59999Z"
      fill="#185C37"
    />
    <path
      d="M12 2H5.93321C5.52828 2 5.20001 2.32826 5.20001 2.7332V6L12 10L15.6 11.2L18.4 10V6L12 2Z"
      fill="#21A366"
    />
    <path d="M5.20001 6H12V10H5.20001V6Z" fill="#107C41" />
    <path
      opacity="0.1"
      d="M10.0668 5.20001H5.20001V15.2H10.0668C10.4712 15.1987 10.7987 14.8712 10.8 14.4668V5.93321C10.7987 5.52882 10.4712 5.20133 10.0668 5.20001Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.66681 5.60001H5.20001V15.6H9.66681C10.0712 15.5987 10.3987 15.2712 10.4 14.8668V6.3332C10.3987 5.92882 10.0712 5.60132 9.66681 5.60001Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.66681 5.60001H5.20001V14.8H9.66681C10.0712 14.7987 10.3987 14.4712 10.4 14.0668V6.3332C10.3987 5.92882 10.0712 5.60132 9.66681 5.60001Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.26681 5.60001H5.20001V14.8H9.26681C9.6712 14.7987 9.99869 14.4712 10 14.0668V6.3332C9.99869 5.92882 9.6712 5.60132 9.26681 5.60001Z"
      fill="black"
    />
    <path
      d="M1.93321 5.60001H9.26681C9.67174 5.60001 10 5.92827 10 6.3332V13.6668C10 14.0717 9.67174 14.4 9.26681 14.4H1.93321C1.52828 14.4 1.20001 14.0717 1.20001 13.6668V6.3332C1.20001 5.92827 1.52828 5.60001 1.93321 5.60001Z"
      fill="url(#paint0_linear_7549_5858)"
    />
    <path
      d="M3.47083 12.3832L5.01322 9.9932L3.60003 7.61639H4.73682L5.50802 9.13639C5.57923 9.28079 5.62802 9.38799 5.65443 9.45879H5.66442C5.71428 9.3453 5.76764 9.23338 5.82442 9.12319L6.64882 7.6172H7.69242L6.24322 9.98L7.72923 12.3832H6.61883L5.72803 10.7148C5.68607 10.6438 5.65046 10.5693 5.62163 10.492H5.60843C5.58234 10.5677 5.54771 10.6401 5.50523 10.708L4.58803 12.3832H3.47083Z"
      fill="white"
    />
    <path
      d="M17.6668 2H12V6H18.4V2.7332C18.4 2.32826 18.0717 2 17.6668 2Z"
      fill="#33C481"
    />
    <path d="M12 10H18.4V14H12V10Z" fill="#107C41" />
    <defs>
      <linearGradient
        id="paint0_linear_7549_5858"
        x1="2.72875"
        y1="5.0271"
        x2="8.47128"
        y2="14.9729"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#18884F" />
        <stop offset="0.5" stop-color="#117E43" />
        <stop offset="1" stop-color="#0B6631" />
      </linearGradient>
    </defs>
  </svg>
);
export const CustomCreditCard = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="40"
    height="38"
    viewBox="0 0 53 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.728 6.35386V19.1846C40.728 19.9539 40.0819 20.6 39.3127 20.6H18.0819C17.3127 20.6 16.6665 19.9846 16.6665 19.1846V6.35386C16.6665 5.58463 17.3127 4.93848 18.0819 4.93848H39.3127C40.0819 4.93848 40.728 5.58463 40.728 6.35386Z"
      fill="#879AAF"
    />
    <g filter="url(#filter0_d_7662_55165)">
      <path
        d="M44.5127 27.0614H24.7896C23.5896 27.0614 22.6357 26.1076 22.6357 24.9076V13.5537C22.6357 12.3537 23.5896 11.3999 24.7896 11.3999H44.5127C45.7127 11.3999 46.6665 12.3537 46.6665 13.5537V24.9076C46.6665 26.1076 45.7127 27.0614 44.5127 27.0614Z"
        fill="#367BF6"
      />
    </g>
    <path
      d="M28.7279 23.5232H25.5895C25.3126 23.5232 25.0972 23.3078 25.0972 23.0309C25.0972 22.754 25.3126 22.5386 25.5895 22.5386H28.7279C29.0049 22.5386 29.2202 22.754 29.2202 23.0309C29.2202 23.3078 29.0049 23.5232 28.7279 23.5232Z"
      fill="white"
    />
    <path
      d="M33.8051 23.5232H30.6666C30.3897 23.5232 30.1743 23.3078 30.1743 23.0309C30.1743 22.754 30.3897 22.5386 30.6666 22.5386H33.8051C34.082 22.5386 34.2974 22.754 34.2974 23.0309C34.2974 23.3078 34.082 23.5232 33.8051 23.5232Z"
      fill="white"
    />
    <path
      d="M38.8817 23.5232H35.7433C35.4664 23.5232 35.251 23.3078 35.251 23.0309C35.251 22.754 35.4664 22.5386 35.7433 22.5386H38.8817C39.1587 22.5386 39.3741 22.754 39.3741 23.0309C39.3741 23.3078 39.1587 23.5232 38.8817 23.5232Z"
      fill="white"
    />
    <path
      d="M43.9589 23.5232H40.8204C40.5435 23.5232 40.3281 23.3078 40.3281 23.0309C40.3281 22.754 40.5435 22.5386 40.8204 22.5386H43.9589C44.2358 22.5386 44.4512 22.754 44.4512 23.0309C44.4512 23.3078 44.2358 23.5232 43.9589 23.5232Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_7662_55165"
        x="0.635742"
        y="0.399902"
        width="68.0308"
        height="59.6616"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7662_55165"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7662_55165"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const LogoPortProColor = ({ className }: IClassNameProps) => (
  <svg
    className={`cicon ${className}`}
    width="160"
    height="50"
    viewBox="0 0 160 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.2165 35C39.1835 35 37.3429 34.5879 35.722 33.7088C34.1011 32.8571 32.8374 31.6758 31.9033 30.1374C30.9692 28.6264 30.5297 26.9231 30.5297 25C30.5297 23.1044 30.9692 21.4011 31.9033 19.8626C32.8374 18.3516 34.1011 17.1703 35.722 16.2912C37.3429 15.4396 39.1835 15 41.2165 15C43.2495 15 45.0627 15.4396 46.6835 16.2912C48.3044 17.1703 49.5681 18.3516 50.5022 19.8626C51.4363 21.4011 51.9033 23.1044 51.9033 25C51.9033 26.9231 51.4363 28.6264 50.5022 30.1374C49.5681 31.6758 48.3044 32.8571 46.6835 33.7088C45.0627 34.5879 43.2495 35 41.2165 35ZM41.2165 30.4945C42.178 30.4945 43.0572 30.2747 43.8539 29.8077C44.6231 29.3681 45.255 28.7088 45.722 27.8846C46.1616 27.0604 46.4088 26.0989 46.4088 25C46.4088 23.9286 46.1616 22.967 45.722 22.1429C45.255 21.3187 44.6231 20.6593 43.8539 20.1923C43.0572 19.7527 42.178 19.5055 41.2165 19.5055C40.2275 19.5055 39.3484 19.7527 38.5791 20.1923C37.7824 20.6593 37.1506 21.3187 36.711 22.1429C36.244 22.967 36.0242 23.9286 36.0242 25C36.0242 26.0989 36.244 27.0604 36.711 27.8846C37.1506 28.7088 37.7824 29.3681 38.5791 29.8077C39.3484 30.2747 40.2275 30.4945 41.2165 30.4945ZM24.5107 16.1264C25.7921 16.7114 26.795 17.5471 27.5193 18.6335C28.2157 19.72 28.5779 21.0014 28.5779 22.45C28.5779 23.9264 28.2157 25.2078 27.5193 26.2664C26.795 27.3528 25.7921 28.1885 24.5107 28.7735C23.2014 29.3585 21.6693 29.6371 19.9143 29.6371H16.5157V34.735H11V25.2914H19.58C20.6943 25.2914 21.5579 25.0685 22.1429 24.5671C22.7 24.0657 23.0064 23.3692 23.0064 22.45C23.0064 21.5585 22.7 20.8342 22.1429 20.3328C21.5579 19.8314 20.6943 19.5807 19.58 19.5807H11V15.235H19.9143C21.6693 15.235 23.2014 15.5414 24.5107 16.1264ZM68.3238 28.5714C69.5051 27.9945 70.4392 27.1978 71.0985 26.1538C71.7578 25.1099 72.0875 23.9011 72.0875 22.5C72.0875 21.0714 71.7304 19.8077 71.0435 18.7363C70.3293 17.6648 69.3403 16.8407 68.0765 16.2637C66.7853 15.6868 65.2743 15.3846 63.5436 15.3846H54.7523V19.6703H63.2139C64.3128 19.6703 65.1644 19.9176 65.7414 20.4121C66.2908 20.9066 66.593 21.6209 66.593 22.5C66.593 23.4066 66.2908 24.0934 65.7414 24.5879C65.1644 25.0824 64.3128 25.3022 63.2139 25.3022H54.7523V34.6154H60.1919V29.5055H63.1589L66.6479 34.6154H72.4721L68.3238 28.5714ZM78.9136 34.6154V19.6978H73.007V15.3846H90.2323V19.6978H84.3532V34.6154H78.9136Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M142.253 35C140.22 35 138.38 34.5879 136.759 33.7088C135.138 32.8571 133.874 31.6758 132.94 30.1374C132.006 28.6264 131.566 26.9231 131.566 25C131.566 23.1044 132.006 21.4011 132.94 19.8626C133.874 18.3516 135.138 17.1703 136.759 16.2912C138.38 15.4396 140.22 15 142.253 15C144.286 15 146.099 15.4396 147.72 16.2912C149.341 17.1703 150.605 18.3516 151.539 19.8626C152.473 21.4011 152.94 23.1044 152.94 25C152.94 26.9231 152.473 28.6264 151.539 30.1374C150.605 31.6758 149.341 32.8571 147.72 33.7088C146.099 34.5879 144.286 35 142.253 35ZM142.253 30.4945C143.215 30.4945 144.094 30.2747 144.891 29.8077C145.66 29.3681 146.292 28.7088 146.759 27.8846C147.198 27.0604 147.446 26.0989 147.446 25C147.446 23.9286 147.198 22.967 146.759 22.1429C146.292 21.3187 145.66 20.6593 144.891 20.1923C144.094 19.7527 143.215 19.5055 142.253 19.5055C141.264 19.5055 140.385 19.7527 139.616 20.1923C138.819 20.6593 138.187 21.3187 137.748 22.1429C137.281 22.967 137.061 23.9286 137.061 25C137.061 26.0989 137.281 27.0604 137.748 27.8846C138.187 28.7088 138.819 29.3681 139.616 29.8077C140.385 30.2747 141.264 30.4945 142.253 30.4945ZM108.55 18.7363C107.836 17.6648 106.847 16.8407 105.583 16.2637C104.292 15.6868 102.781 15.3846 101.05 15.3846H92.2588V19.6703H100.72C101.819 19.6703 102.671 19.9176 103.248 20.4121C103.797 20.9066 104.099 21.6209 104.099 22.5C104.099 23.4066 103.797 24.0934 103.248 24.5879C102.671 25.0824 101.819 25.3022 100.72 25.3022H92.2588V34.6154H97.6984V29.5879H101.05C102.781 29.5879 104.292 29.3132 105.583 28.7363C106.847 28.1593 107.836 27.3352 108.55 26.2637C109.237 25.2198 109.594 23.956 109.594 22.5C109.594 21.0714 109.237 19.8077 108.55 18.7363ZM125.791 28.5714C126.972 27.9945 127.906 27.1978 128.565 26.1538C129.225 25.1099 129.554 23.9011 129.554 22.5C129.554 21.0714 129.197 19.8077 128.51 18.7363C127.796 17.6648 126.807 16.8407 125.543 16.2637C124.252 15.6868 122.741 15.3846 121.01 15.3846H112.219V19.6703H120.681C121.78 19.6703 122.631 19.9176 123.208 20.4121C123.758 20.9066 124.06 21.6209 124.06 22.5C124.06 23.4066 123.758 24.0934 123.208 24.5879C122.631 25.0824 121.78 25.3022 120.681 25.3022H112.219V34.6154H117.659V29.5055H120.626L124.115 34.6154H129.939L125.791 28.5714Z"
      fill="#00A6FF"
    />
  </svg>
);

export const CustomRocket = ({ className }: IClassNameProps) => (
  <svg
    width="134"
    className={`cicon ${className}`}
    height="128"
    viewBox="0 0 134 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M70.825 101.6C98.825 101.6 121.525 78.9 121.525 50.8C121.525 22.7 98.725 0 70.825 0C42.825 0 20.125 22.7 20.125 50.8C20.125 78.9 42.825 101.6 70.825 101.6Z"
      fill="#C2D6FC"
    />
    <path
      d="M124.675 83.577C126.939 83.577 128.775 81.7413 128.775 79.477C128.775 77.2126 126.939 75.377 124.675 75.377C122.41 75.377 120.575 77.2126 120.575 79.477C120.575 81.7413 122.41 83.577 124.675 83.577Z"
      fill="#EAEEF9"
    />
    <path
      d="M130.675 67.5771C132.221 67.5771 133.475 66.3234 133.475 64.7771C133.475 63.2307 132.221 61.9771 130.675 61.9771C129.129 61.9771 127.875 63.2307 127.875 64.7771C127.875 66.3234 129.129 67.5771 130.675 67.5771Z"
      fill="#EAEEF9"
    />
    <path
      d="M22.8249 17.3998C24.3713 17.3998 25.6249 16.1462 25.6249 14.5998C25.6249 13.0534 24.3713 11.7998 22.8249 11.7998C21.2785 11.7998 20.0249 13.0534 20.0249 14.5998C20.0249 16.1462 21.2785 17.3998 22.8249 17.3998Z"
      fill="#EAEEF9"
    />
    <path
      d="M5.7249 71.4C8.59678 71.4 10.9249 69.0719 10.9249 66.2C10.9249 63.3281 8.59678 61 5.7249 61C2.85302 61 0.524902 63.3281 0.524902 66.2C0.524902 69.0719 2.85302 71.4 5.7249 71.4Z"
      fill="#EAEEF9"
    />
    <path
      d="M108.637 51.9994L111.339 51.1849C111.535 51.1281 111.535 50.8439 111.339 50.7871L108.637 49.9726C108.567 49.9536 108.517 49.9031 108.498 49.8337L107.683 47.1375C107.627 46.9418 107.342 46.9418 107.286 47.1375L106.471 49.8337C106.452 49.9031 106.402 49.9536 106.332 49.9726L103.636 50.7871C103.44 50.8439 103.44 51.1281 103.636 51.1849L106.339 51.9994C106.408 52.0183 106.458 52.0689 106.477 52.1383L107.292 54.8408C107.349 55.0365 107.633 55.0365 107.69 54.8408L108.504 52.1383C108.517 52.0689 108.567 52.0183 108.637 51.9994Z"
      fill="#9ABBFB"
    />
    <path
      d="M92.6369 22.9996L95.3393 22.1852C95.535 22.1283 95.535 21.8442 95.3393 21.7874L92.6369 20.9729C92.5674 20.954 92.5169 20.9035 92.4979 20.834L91.6834 18.138C91.6266 17.9423 91.3425 17.9423 91.2856 18.138L90.4711 20.834C90.4522 20.9035 90.4017 20.954 90.3322 20.9729L87.6361 21.7874C87.4403 21.8442 87.4403 22.1283 87.6361 22.1852L90.3385 22.9996C90.408 23.0186 90.4585 23.0691 90.4774 23.1385L91.2919 25.8409C91.3488 26.0366 91.6329 26.0366 91.6897 25.8409L92.5043 23.1385C92.5169 23.0691 92.5674 23.0186 92.6369 22.9996Z"
      fill="#9ABBFB"
    />
    <path
      d="M51.9934 26.3736L54.358 25.6609C54.5293 25.6112 54.5293 25.3626 54.358 25.3128L51.9934 24.6002C51.9326 24.5836 51.8884 24.5394 51.8719 24.4786L51.1591 22.1197C51.1094 21.9484 50.8608 21.9484 50.8111 22.1197L50.0984 24.4786C50.0818 24.5394 50.0376 24.5836 49.9768 24.6002L47.6177 25.3128C47.4464 25.3626 47.4464 25.6112 47.6177 25.6609L49.9824 26.3736C50.0431 26.3901 50.0873 26.4343 50.1039 26.4951L50.8166 28.8596C50.8663 29.0309 51.1149 29.0309 51.1647 28.8596L51.8774 26.4951C51.8884 26.4343 51.9326 26.3901 51.9934 26.3736Z"
      fill="#9ABBFB"
    />
    <path
      d="M34.9934 69.8021L37.358 68.9876C37.5293 68.9308 37.5293 68.6467 37.358 68.5898L34.9934 67.7753C34.9326 67.7564 34.8884 67.7058 34.8719 67.6364L34.1591 64.9403C34.1094 64.7445 33.8608 64.7445 33.8111 64.9403L33.0984 67.6364C33.0818 67.7058 33.0376 67.7564 32.9768 67.7753L30.6177 68.5898C30.4464 68.6467 30.4464 68.9308 30.6177 68.9876L32.9824 69.8021C33.0431 69.8211 33.0873 69.8716 33.1039 69.9411L33.8166 72.6435C33.8663 72.8392 34.1149 72.8392 34.1647 72.6435L34.8774 69.9411C34.8884 69.8716 34.9326 69.8211 34.9934 69.8021Z"
      fill="#9ABBFB"
    />
    <path
      d="M31.2075 39.0052L32.8965 38.4961C33.0188 38.4606 33.0188 38.2831 32.8965 38.2475L31.2075 37.7385C31.1641 37.7267 31.1325 37.6951 31.1207 37.6517L30.6116 35.9667C30.5761 35.8444 30.3985 35.8444 30.363 35.9667L29.8539 37.6517C29.8421 37.6951 29.8105 37.7267 29.7671 37.7385L28.082 38.2475C27.9597 38.2831 27.9597 38.4606 28.082 38.4961L29.771 39.0052C29.8144 39.017 29.846 39.0486 29.8578 39.092L30.3669 40.7809C30.4024 40.9032 30.58 40.9032 30.6155 40.7809L31.1246 39.092C31.1325 39.0486 31.1641 39.017 31.2075 39.0052Z"
      fill="#9ABBFB"
    />
    <path
      d="M49.207 55.7112L50.896 55.2022C51.0184 55.1667 51.0184 54.9891 50.896 54.9536L49.207 54.4446C49.1636 54.4327 49.132 54.4012 49.1202 54.3577L48.6111 52.6728C48.5756 52.5505 48.398 52.5505 48.3625 52.6728L47.8534 54.3577C47.8416 54.4012 47.81 54.4327 47.7666 54.4446L46.0815 54.9536C45.9592 54.9891 45.9592 55.1667 46.0815 55.2022L47.7705 55.7112C47.8139 55.7231 47.8455 55.7546 47.8573 55.798L48.3664 57.4869C48.4019 57.6093 48.5795 57.6093 48.615 57.4869L49.1241 55.798C49.132 55.7546 49.1636 55.7231 49.207 55.7112Z"
      fill="#9ABBFB"
    />
    <path
      d="M63.5288 8.11993L65.2178 7.61089C65.3401 7.57537 65.3401 7.3978 65.2178 7.36229L63.5288 6.85325C63.4854 6.84142 63.4538 6.80985 63.442 6.76644L62.9329 5.08149C62.8974 4.95916 62.7198 4.95916 62.6843 5.08149L62.1752 6.76644C62.1633 6.80985 62.1318 6.84142 62.0884 6.85325L60.4033 7.36229C60.2809 7.3978 60.2809 7.57537 60.4033 7.61089L62.0923 8.11993C62.1357 8.13176 62.1673 8.16333 62.1791 8.20674L62.6882 9.89563C62.7237 10.018 62.9013 10.018 62.9368 9.89563L63.4459 8.20674C63.4538 8.16333 63.4854 8.13176 63.5288 8.11993Z"
      fill="#9ABBFB"
    />
    <path
      d="M103.552 80.4705L105.241 79.9615C105.363 79.926 105.363 79.7484 105.241 79.7129L103.552 79.2038C103.508 79.192 103.477 79.1604 103.465 79.117L102.956 77.4321C102.92 77.3098 102.743 77.3098 102.707 77.4321L102.198 79.117C102.186 79.1604 102.155 79.192 102.111 79.2038L100.426 79.7129C100.304 79.7484 100.304 79.926 100.426 79.9615L102.115 80.4705C102.159 80.4823 102.19 80.5139 102.202 80.5573L102.711 82.2462C102.747 82.3685 102.924 82.3685 102.96 82.2462L103.469 80.5573C103.477 80.5139 103.508 80.4823 103.552 80.4705Z"
      fill="#9ABBFB"
    />
    <path
      d="M55.8904 58.5508C51.6376 61.6492 46.0483 66.1449 46.0483 70.0939C46.0483 72.4067 46.0483 75.6991 46.0483 78.0302C46.0483 78.9719 47.3973 79.5413 48.1758 79.0115C50.2275 77.6152 53.7747 76.0068 58.8673 76.473C67.4942 77.2628 57.3484 62.8035 57.3484 62.8035L55.8904 58.5508Z"
      fill="#367BF6"
    />
    <path
      d="M86.8138 58.5508C91.0665 61.7099 96.6558 66.1449 96.6558 70.0939C96.6558 72.4067 96.6558 75.6991 96.6558 78.0302C96.6558 78.9719 95.3068 79.5413 94.5283 79.0115C92.4766 77.6153 88.9295 76.0068 83.8369 76.473C75.2099 77.2628 85.3557 62.8035 85.3557 62.8035L86.8138 58.5508Z"
      fill="#367BF6"
    />
    <g filter="url(#filter0_d_8084_72354)">
      <path
        d="M71.3219 15.0513C63.3025 20.7621 53.7035 34.7961 55.4653 52.6575C57.1664 70.5189 58.6852 79.3281 61.9659 81.4545C65.3073 83.5809 68.588 84.0669 71.3219 84.0669C74.0558 84.0669 77.3364 83.5809 80.6779 81.4545C84.0193 79.3281 85.4774 70.5189 87.1785 52.6575C88.8796 34.7961 79.2805 20.7621 71.3219 15.0513Z"
        fill="url(#paint0_linear_8084_72354)"
      />
    </g>
    <g filter="url(#filter1_d_8084_72354)">
      <path
        d="M77.3971 86.5579H65.2465C64.2744 86.5579 63.5454 85.7681 63.5454 84.8568V81.8799H79.159V84.796C79.0982 85.7681 78.3084 86.5579 77.3971 86.5579Z"
        fill="url(#paint1_linear_8084_72354)"
      />
    </g>
    <path
      d="M72.1723 57.5786H70.4712V79.9965H72.1723V57.5786Z"
      fill="#367BF6"
    />
    <path
      d="M71.3217 45.367C74.6434 45.367 77.3363 42.6742 77.3363 39.3525C77.3363 36.0307 74.6434 33.3379 71.3217 33.3379C67.9999 33.3379 65.3071 36.0307 65.3071 39.3525C65.3071 42.6742 67.9999 45.367 71.3217 45.367Z"
      stroke="#394E66"
      stroke-width="4"
      stroke-miterlimit="10"
    />
    <path
      d="M79.6447 98.1615C79.6447 103.082 75.6958 127.748 70.7748 127.748C65.8537 127.748 61.9048 103.082 61.9048 98.1615C61.9048 93.2405 65.8537 89.2915 70.7748 89.2915C75.6958 89.2915 79.6447 93.3012 79.6447 98.1615Z"
      fill="#EAEEF9"
    />
    <path
      d="M70.775 116.388C69.0132 112.621 67.0083 102.172 67.0083 98.8302C67.0083 96.7646 68.7094 95.0635 70.775 95.0635C72.8406 95.0635 74.5417 96.7646 74.5417 98.8302C74.5417 102.172 72.5368 112.56 70.775 116.388Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_8084_72354"
        x="33.2539"
        y="4.05127"
        width="76.1226"
        height="113.016"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8084_72354"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8084_72354"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_8084_72354"
        x="41.5454"
        y="70.8799"
        width="59.6138"
        height="48.6782"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8084_72354"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8084_72354"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_8084_72354"
        x1="71.3047"
        y1="13.4549"
        x2="71.3047"
        y2="84.8109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8084_72354"
        x1="71.3471"
        y1="81.7717"
        x2="71.3471"
        y2="86.6083"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomTerminalIcon = ({ className }: IClassNameProps) => (
  <svg width="60" height="30" viewBox="0 0 60 30" fill="none"  className={`cicon ${className}`} xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.1179 4.2117C11.1007 4.20595 11.0835 4.2002 11.072 4.2002H10.1302C10.1072 4.2002 10.09 4.20595 10.0727 4.2117C10.0555 4.21746 10.0383 4.22321 10.0153 4.22321C8.91271 4.29227 7.83308 4.52245 6.79939 4.91375C5.51302 5.42014 4.3415 6.15672 3.33078 7.12347C1.86064 8.50454 0.872894 10.1848 0.367534 12.1184C0.229709 12.6938 0.114855 13.2692 0.0689127 13.8447C0.0574273 13.9253 0.0516845 14.0001 0.0459418 14.0749C0.0401991 14.1497 0.0344564 14.2245 0.0229709 14.3051C0.0229709 14.3166 0.0172282 14.3223 0.0114855 14.3281C0.00574317 14.3338 0 14.3396 0 14.3511V15.2948C0.0229709 15.3639 0.0459418 15.4329 0.0459418 15.502C0.137825 16.86 0.459418 18.126 1.03369 19.346C1.58499 20.5199 2.32006 21.5557 3.26187 22.4534C4.68606 23.8345 6.36294 24.7322 8.31547 25.1235C8.8438 25.2386 9.37213 25.3306 9.92343 25.3536C9.93491 25.3536 9.94639 25.3594 9.95787 25.3652C9.96936 25.3709 9.98086 25.3767 9.99234 25.3767H11.2787C11.3017 25.3536 11.3247 25.3536 11.3476 25.3536L11.9678 25.2846C12.634 25.1925 13.2772 25.0544 13.9204 24.8473C15.6202 24.2948 17.0904 23.3741 18.3308 22.0621C19.2266 21.1184 19.9158 20.0365 20.4211 18.8396C20.8116 17.9189 21.0413 16.9521 21.1562 15.9393C21.2251 15.479 21.2251 14.9956 21.2251 14.5352C21.2251 14.4803 21.2199 14.4254 21.2144 14.368C21.2084 14.3051 21.2021 14.2391 21.2021 14.1669H18.7443C18.753 14.1494 18.7585 14.1351 18.7631 14.123C18.7706 14.1033 18.776 14.0891 18.7902 14.0749C19.0199 13.626 19.2554 13.1829 19.4908 12.7398C19.7263 12.2967 19.9617 11.8536 20.1914 11.4048C20.2144 11.3588 20.2374 11.3357 20.3063 11.3357H20.6049C20.5948 11.3156 20.5892 11.2954 20.5841 11.2771C20.5775 11.2538 20.5719 11.2336 20.559 11.2207C20.4786 11.0462 20.406 10.8638 20.3322 10.6783C20.2794 10.5456 20.2259 10.4112 20.1685 10.2769C20.1455 10.1848 20.0995 10.1618 20.0077 10.1618H16.2404C16.2519 10.1503 16.2577 10.1331 16.2634 10.1158C16.2691 10.0985 16.2749 10.0813 16.2864 10.0698C16.539 9.6094 16.7917 9.12603 17.0444 8.64265C17.1593 8.42398 17.2684 8.21106 17.3775 7.99815L17.3777 7.99775C17.4867 7.78497 17.5958 7.57218 17.7106 7.35365C17.7335 7.30761 17.7565 7.28459 17.8254 7.28459H18.0322L17.9403 7.19252C17.1133 6.36388 16.1485 5.71938 15.0919 5.21298C13.8515 4.61452 12.5421 4.29227 11.1639 4.22321C11.1524 4.22321 11.1351 4.21746 11.1179 4.2117ZM18.8786 12.2927C18.5439 12.9375 18.2129 13.5753 17.8714 14.213H16.4472C16.4472 14.2015 16.4529 14.19 16.4586 14.1785C16.4644 14.167 16.4701 14.1554 16.4701 14.1439C16.7113 13.6951 16.9468 13.2405 17.1822 12.7859C17.4177 12.3313 17.6531 11.8767 17.8943 11.4278C17.9173 11.3818 17.9403 11.3588 17.9862 11.3588H19.3645C19.2006 11.6722 19.0392 11.9833 18.8786 12.2927ZM14.196 14.213C14.196 14.1209 15.4824 11.658 15.6662 11.3588H17.0444C16.8805 11.6722 16.7191 11.9833 16.5585 12.2927C16.2238 12.9375 15.8928 13.5753 15.5513 14.213H14.196ZM12.1286 14.213C12.1286 14.1209 13.4609 11.5659 13.5988 11.3588H14.6554C14.6554 11.4508 13.2772 14.0749 13.1853 14.213H12.1286ZM16.7688 7.30761C16.2864 8.27431 15.7811 9.21799 15.2757 10.1617L14.196 10.1618C14.2075 10.1503 14.2132 10.1331 14.219 10.1158C14.2247 10.0985 14.2305 10.0813 14.242 10.0698C14.3888 9.79021 14.538 9.50832 14.688 9.22482L14.6881 9.22455L14.6883 9.22414C15.0076 8.62082 15.3307 8.01025 15.6432 7.39968C15.6891 7.33063 15.7121 7.30761 15.781 7.30761H16.7688ZM14.3798 7.33063C14.0383 7.96831 13.7073 8.60599 13.3727 9.25077L13.3717 9.25267C13.2114 9.5615 13.0502 9.87197 12.8867 10.1849H11.8989C11.8989 10.1618 11.8989 10.1388 11.9219 10.1158C12.1516 9.66695 12.3871 9.2181 12.6225 8.76925C12.858 8.3204 13.0934 7.87155 13.3231 7.4227C13.3461 7.37667 13.3691 7.33063 13.438 7.33063H14.3798ZM10.5551 12.7744C10.8021 12.3025 11.049 11.8306 11.3017 11.3588H12.3124C11.807 12.3025 11.3017 13.2462 10.8193 14.19H9.80858C10.0613 13.7181 10.3082 13.2462 10.5551 12.7744ZM8.98162 12.7974C8.73468 13.2693 8.48775 13.7411 8.24655 14.213H7.48851C7.48851 14.2015 7.49426 14.19 7.5 14.1785C7.50574 14.167 7.51148 14.1554 7.51148 14.1439C7.74119 13.6951 7.97665 13.2462 8.2121 12.7974C8.44755 12.3485 8.683 11.8997 8.91271 11.4508C8.93568 11.4048 8.95865 11.3818 9.02756 11.3818H9.71669C9.4755 11.8536 9.22856 12.3255 8.98162 12.7974ZM11.807 7.30761C11.3017 8.27436 10.8193 9.2181 10.3369 10.1618H9.5559C9.56738 10.1273 9.58461 10.0985 9.60184 10.0698C9.61907 10.041 9.63629 10.0122 9.64778 9.97769C9.86585 9.55215 10.0897 9.12086 10.3135 8.68957L10.3137 8.68923L10.3139 8.68868L10.3141 8.68836C10.538 8.25688 10.7619 7.82541 10.9801 7.39968C11.0031 7.33063 11.049 7.30761 11.1179 7.30761H11.807ZM8.8491 8.30268C8.52019 8.9267 8.19469 9.54427 7.87902 10.1618H7.44257C7.45135 10.1442 7.45677 10.13 7.4614 10.1179C7.46889 10.0982 7.47432 10.084 7.48851 10.0698C7.64931 9.77053 7.80436 9.46554 7.95942 9.16055C8.11447 8.85557 8.26952 8.55058 8.43032 8.25135C8.48473 8.14231 8.54272 8.03327 8.60146 7.92282C8.69151 7.75348 8.78336 7.58078 8.86677 7.39968C8.91271 7.33063 8.93568 7.30761 9.02756 7.30761H9.37213C9.19755 7.64157 9.02298 7.97278 8.84935 8.3022L8.8491 8.30268ZM5.78867 14.19H5.35222C5.85758 13.2462 6.33997 12.3025 6.79939 11.3588H7.23583C7.23583 11.4278 5.92649 13.9598 5.78867 14.19ZM5.39816 10.1618H5.19142C5.26034 10.0467 5.30628 9.93165 5.35222 9.81656C5.60198 9.31602 5.86013 8.82387 6.11653 8.33505C6.28459 8.01464 6.45191 7.69565 6.61562 7.37667C6.66156 7.33063 6.68453 7.30761 6.75345 7.30761H6.91424C6.90417 7.3278 6.89851 7.34798 6.8934 7.36623C6.88685 7.38959 6.8812 7.40978 6.8683 7.4227C6.74196 7.66439 6.62136 7.90032 6.50077 8.13626C6.38017 8.37219 6.25957 8.60812 6.13323 8.84981C6.02986 9.04546 5.92649 9.24687 5.82312 9.44828C5.71976 9.64968 5.61639 9.85109 5.51302 10.0467C5.50153 10.0583 5.49579 10.0698 5.49005 10.0813C5.4843 10.0928 5.47856 10.1043 5.46708 10.1158C5.46708 10.1618 5.42113 10.1618 5.39816 10.1618Z" fill="#172A41"/>
<path d="M56.7726 11.8306C56.7898 11.7443 56.807 11.658 56.83 11.5659V10.8984C56.83 10.8869 56.8243 10.8811 56.8185 10.8754C56.8128 10.8696 56.807 10.8639 56.807 10.8524C56.7841 10.5762 56.6463 10.346 56.4625 10.1388C56.2328 9.90864 55.9342 9.77053 55.6126 9.70148C55.1991 9.60941 54.7626 9.60941 54.3492 9.67846C53.6371 9.77053 53.0628 10.1158 52.6493 10.7373C52.3737 11.1746 52.2129 11.635 52.098 12.1414L51.5467 14.6964C51.4548 15.1107 51.3629 15.548 51.4089 15.9854C51.4319 16.3767 51.5467 16.7219 51.8453 16.9982C52.0521 17.2053 52.3277 17.3204 52.6034 17.3664C53.1087 17.4585 53.6141 17.4355 54.0965 17.3434C54.51 17.2514 54.8545 17.0902 55.1761 16.837C55.5437 16.5378 55.7734 16.1465 55.9342 15.7092C56.0593 15.3689 56.1288 15.0146 56.1967 14.6681C56.2161 14.5693 56.2354 14.4711 56.2557 14.3741V14.3281H54.5559C54.5559 14.355 54.548 14.3741 54.5415 14.3899C54.5369 14.4011 54.5329 14.4106 54.5329 14.4201C54.5023 14.5352 54.4768 14.6503 54.4513 14.7654C54.4002 14.9956 54.3492 15.2258 54.2573 15.456C54.2113 15.571 54.1654 15.6861 54.0965 15.8012C54.0046 15.9393 53.8668 16.0544 53.683 16.0774C53.4074 16.1235 53.1776 15.9623 53.1317 15.6861C53.1087 15.5941 53.1087 15.525 53.1087 15.4329C53.1317 15.2258 53.1547 15.0186 53.2006 14.8115L53.683 12.5327C53.7519 12.2104 53.8208 11.9112 53.9127 11.612C53.9587 11.4508 54.0505 11.2897 54.1654 11.1516C54.3262 10.9675 54.5329 10.8754 54.7856 10.9214C54.9923 10.9444 55.1072 11.0595 55.1302 11.2667C55.1531 11.3588 55.1531 11.4508 55.1302 11.5199C55.1072 11.6234 55.0842 11.7327 55.0613 11.842C55.0383 11.9514 55.0153 12.0608 54.9923 12.1644C54.9809 12.1989 54.9751 12.2334 54.9694 12.268C54.9636 12.3025 54.9579 12.337 54.9464 12.3716H56.6463L56.7152 12.0953C56.7381 12.0033 56.7554 11.917 56.7726 11.8306Z" fill="#172A41"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M40.3647 14.9011L40.3645 14.9019C40.204 15.6647 40.0443 16.4235 39.8775 17.1823H38.0398C38.3844 15.5365 38.7347 13.8965 39.085 12.2565C39.4353 10.6164 39.7856 8.9764 40.1302 7.33062H43.8515C44.0582 7.33062 44.2879 7.35364 44.4946 7.39968C45.0689 7.53779 45.4135 7.90607 45.5743 8.4585C45.6891 8.82679 45.6891 9.19508 45.6432 9.56336C45.5743 10.1848 45.4135 10.8063 45.1149 11.3588C44.6325 12.2795 43.8515 12.7859 42.8637 12.97C42.5651 13.016 42.2665 13.0391 41.9678 13.0391H40.9112C40.8652 13.0851 40.8193 13.0851 40.7504 13.0851C40.6188 13.6938 40.4916 14.298 40.365 14.8997L40.365 14.9L40.3649 14.9004L40.3647 14.9011ZM41.072 11.5889C41.0835 11.5889 41.0892 11.5947 41.0949 11.6004C41.1007 11.6062 41.1064 11.612 41.1179 11.612C41.2472 11.612 41.3791 11.6145 41.5118 11.617C41.7798 11.6222 42.0512 11.6273 42.3124 11.612C42.7948 11.5889 43.1853 11.3357 43.438 10.8984C43.5988 10.6222 43.6907 10.2999 43.7366 9.97768C43.7825 9.77052 43.8055 9.58638 43.7596 9.37922C43.7136 9.14904 43.5988 8.9649 43.3691 8.89584C43.2312 8.84981 43.0934 8.82679 42.9556 8.80377C42.5421 8.78075 42.1516 8.78075 41.7381 8.78075C41.7152 8.78075 41.6922 8.78075 41.6692 8.80377C41.5781 9.21969 41.4915 9.63113 41.4053 10.0401L41.4053 10.0405L41.4052 10.0409L41.4051 10.0412L41.405 10.0417C41.2958 10.5601 41.1875 11.0745 41.072 11.5889Z" fill="#172A41"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M45.827 11.9803H47.4579C47.4579 11.9342 47.4579 11.9112 47.5268 11.8191C47.5432 11.7697 47.5567 11.7174 47.5704 11.6642C47.5951 11.5687 47.6204 11.4705 47.6646 11.3818C47.7795 11.1056 47.9862 10.9445 48.2619 10.8754C48.5146 10.8294 48.7672 10.8294 49.0199 10.8754C49.2266 10.8984 49.3185 11.0365 49.3185 11.2437C49.2956 11.5429 49.2037 11.8191 48.951 12.0263C48.8361 12.1414 48.6983 12.2335 48.5375 12.3025C48.2159 12.4406 47.8943 12.5787 47.5727 12.6938C47.1593 12.8549 46.7458 13.0391 46.3783 13.2693C45.8729 13.5915 45.5054 14.0058 45.2757 14.5583C45.1608 14.8575 45.0919 15.1798 45.0459 15.502C45 15.8012 45 16.0775 45.0459 16.3537C45.1378 16.768 45.3675 17.0672 45.758 17.2053C45.9188 17.2514 46.0796 17.2974 46.2404 17.3204C46.6769 17.3895 47.0904 17.3434 47.4809 17.1133C47.7565 16.9752 48.0092 16.768 48.2159 16.5378C48.2308 16.5081 48.2552 16.488 48.283 16.465C48.2982 16.4524 48.3145 16.439 48.3308 16.4227C48.3078 16.5608 48.2848 16.6759 48.2619 16.791C48.2389 16.9291 48.2389 17.0442 48.2848 17.1593H49.8928V17.0902C49.8698 16.814 49.8928 16.5378 49.9387 16.2616C49.9688 16.1111 50.0032 15.9563 50.0381 15.799L50.0385 15.7975C50.0836 15.5944 50.1297 15.387 50.1685 15.1798C50.2948 14.6043 50.4154 14.0288 50.536 13.4533L50.5362 13.4522C50.6568 12.8772 50.7773 12.3021 50.9035 11.7271C50.9724 11.4509 51.0414 11.1746 51.0184 10.8754C51.0184 10.392 50.7887 10.0237 50.3293 9.81658C50.2885 9.80297 50.2478 9.78735 50.2064 9.77151C50.1079 9.73374 50.0061 9.69469 49.8928 9.67848C49.2037 9.54037 48.5146 9.56339 47.8254 9.70149C47.4579 9.79356 47.1133 9.93167 46.8147 10.1619C46.2175 10.6222 45.9877 11.2667 45.827 11.9803ZM48.8361 13.3153L48.8591 13.3383C48.8132 13.5455 48.7672 13.7296 48.6983 13.8908C48.6064 14.3051 48.5146 14.7194 48.3997 15.1337C48.3538 15.3179 48.2619 15.502 48.147 15.6631C47.8714 16.0314 47.4809 16.1005 47.1133 16.0084C46.9066 15.9624 46.7688 15.8012 46.7688 15.5711C46.7688 15.1798 46.8377 14.8115 47.0674 14.4662C47.1363 14.3741 47.2282 14.2821 47.343 14.213C47.5827 14.0576 47.831 13.9109 48.0827 13.7622C48.241 13.6686 48.4008 13.5742 48.5605 13.4764C48.6524 13.4074 48.7443 13.3613 48.8361 13.3153Z" fill="#172A41"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M34.2726 11.9802H32.6646C32.6646 11.9342 32.6646 11.9112 32.6876 11.8652C32.7565 11.5429 32.8484 11.2207 33.0092 10.9214C33.3308 10.2999 33.8361 9.93165 34.5023 9.74751C34.8009 9.65544 35.0995 9.63242 35.3982 9.6094C35.7887 9.58638 36.2021 9.58638 36.5927 9.65544C36.8913 9.70147 37.1899 9.79354 37.4196 10.0007C37.6493 10.1848 37.7871 10.438 37.8331 10.7373C37.879 11.0595 37.8331 11.3588 37.7642 11.658C37.6378 12.268 37.5057 12.8779 37.3737 13.4879L37.3734 13.489C37.2414 14.0986 37.1094 14.7082 36.9832 15.3178C36.9521 15.4841 36.9163 15.6503 36.88 15.8186C36.836 16.0232 36.7913 16.231 36.7534 16.4457C36.7259 16.5838 36.7231 16.7219 36.7204 16.86C36.7185 16.9521 36.7167 17.0442 36.7075 17.1363V17.2053H35.0995C35.0306 16.9751 35.0766 16.7219 35.1455 16.4687L34.8009 16.814C34.5023 17.0902 34.1348 17.3204 33.7213 17.3895C33.3078 17.4585 32.9173 17.4355 32.5268 17.2744C32.1363 17.1132 31.9066 16.791 31.8606 16.3767C31.7917 15.479 31.9525 14.6503 32.5268 13.9368C32.8025 13.6145 33.147 13.3613 33.5146 13.1772C33.9185 12.9748 34.358 12.808 34.7861 12.6455L34.8941 12.6045L34.9617 12.5787C35.2144 12.4866 35.4671 12.3715 35.6738 12.2334C35.9724 12.0263 36.1332 11.727 36.1103 11.3588C36.1103 11.1516 36.0184 11.0365 35.8116 10.9905C35.6049 10.9444 35.3982 10.9444 35.1914 10.9675C35.1225 10.9675 35.0536 10.9905 34.9847 11.0135C34.755 11.0825 34.5712 11.2207 34.4564 11.4278C34.3874 11.5659 34.3415 11.727 34.2956 11.8882C34.2726 11.8882 34.2726 11.9342 34.2726 11.9802ZM35.6508 13.3153L35.3063 13.5224C34.9158 13.7526 34.5252 13.9828 34.1348 14.236C33.9969 14.3281 33.8821 14.4662 33.8132 14.6043C33.6524 14.9035 33.5835 15.2488 33.5835 15.5941C33.5835 15.8473 33.7443 16.0084 33.9969 16.0774C34.4334 16.1695 34.8239 16.0084 35.0536 15.6171C35.1685 15.4099 35.2603 15.2028 35.3063 14.9726C35.3637 14.7194 35.4211 14.4604 35.4786 14.2015C35.536 13.9425 35.5934 13.6836 35.6508 13.4304V13.3153Z" fill="#172A41"/>
<path d="M24.0046 17.1823H25.8423C26.4395 14.3971 27.0368 11.6119 27.634 8.80376H29.7703C29.8162 8.56208 29.8679 8.32039 29.9196 8.0787C29.9713 7.83701 30.023 7.59533 30.0689 7.35364H23.9357C23.8897 7.59533 23.8381 7.83701 23.7864 8.0787C23.7347 8.32039 23.683 8.56208 23.6371 8.80376H25.245C25.297 8.80376 25.3514 8.80136 25.4074 8.79888C25.5247 8.79369 25.649 8.78819 25.7734 8.80376C25.1991 11.5889 24.6018 14.3971 24.0046 17.1823Z" fill="#172A41"/>
<path d="M29.242 9.79355H30.8959C30.804 10.2079 30.7121 10.6222 30.6432 11.0595C30.6432 11.0595 30.6662 11.0595 30.6662 11.0826C30.6776 11.071 30.6891 11.0538 30.7006 11.0365C30.7121 11.0193 30.7236 11.002 30.7351 10.9905C30.9188 10.6913 31.1256 10.415 31.4012 10.2079C31.6539 10.0007 31.9525 9.81657 32.2741 9.74752C32.4119 9.7245 32.5498 9.70148 32.7106 9.70148C32.5727 10.392 32.4349 11.0595 32.2741 11.7271H31.7688C31.3553 11.7501 30.9878 11.8652 30.7121 12.1644C30.5054 12.3946 30.3905 12.6478 30.3216 12.947C30.2529 13.2684 30.1842 13.584 30.1154 13.8996L30.1143 13.9049C30.0456 14.2205 29.9768 14.5361 29.9081 14.8575C29.8277 15.2373 29.7473 15.6228 29.6669 16.0084C29.5865 16.3939 29.5061 16.7795 29.4257 17.1593C29.4257 17.1688 29.4218 17.1784 29.4172 17.1895C29.4106 17.2053 29.4028 17.2244 29.4028 17.2514H27.7029C27.8178 16.6299 27.9556 16.0084 28.0934 15.4099C28.1559 15.1281 28.2137 14.8463 28.271 14.5667C28.3401 14.2296 28.4086 13.8956 28.4839 13.5685C28.5464 13.2867 28.6042 13.0049 28.6615 12.7252C28.7306 12.3881 28.7991 12.0542 28.8744 11.7271C28.9893 11.0365 29.1041 10.415 29.242 9.79355Z" fill="#172A41"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M58.5299 9.10301H58.7596V8.64265H58.8744L59.1041 9.10301H59.3798L59.1271 8.61963C59.2879 8.59662 59.4028 8.52756 59.4028 8.3204C59.4028 8.0672 59.242 7.97513 58.9433 7.97513H58.5299V9.10301ZM58.9893 8.43549H58.8055V8.18229H58.9663C59.1271 8.18229 59.173 8.20531 59.173 8.29738C59.173 8.38945 59.1271 8.43549 58.9893 8.43549Z" fill="#172A41"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M60 8.55058C60 7.9291 59.4946 7.53779 58.9433 7.53779C58.392 7.53779 57.8867 7.90608 57.8867 8.55058C57.8867 9.19508 58.392 9.56337 58.9433 9.56337C59.4946 9.56337 60 9.17206 60 8.55058ZM58.2083 8.55058C58.2083 8.09022 58.5299 7.76797 58.9433 7.76797C59.3568 7.76797 59.6784 8.09022 59.6784 8.55058C59.6784 9.01094 59.3568 9.33319 58.9433 9.33319C58.5299 9.33319 58.2083 9.01094 58.2083 8.55058Z" fill="#172A41"/>
</svg>

);



